import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, mergeProps as _mergeProps, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vModelText as _vModelText, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withKeys as _withKeys, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "chat-over-limit" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "chat incoming" }
const _hoisted_4 = { class: "chat-content" }
const _hoisted_5 = { class: "chat-details" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "message-content" }
const _hoisted_8 = ["data-message-id"]
const _hoisted_9 = { class: "chat-content" }
const _hoisted_10 = { class: "chat-details" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  class: /*@__PURE__*/_normalizeClass(`message-content`)
}
const _hoisted_13 = {
  key: 0,
  class: "agent-activity-timeline",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_14 = { class: "agent-activity-heading" }
const _hoisted_15 = { class: "agent-activity-rail" }
const _hoisted_16 = { class: "agent-activity-icon" }
const _hoisted_17 = {
  key: 0,
  class: "agent-activity-line"
}
const _hoisted_18 = { class: "agent-activity-body" }
const _hoisted_19 = { class: "agent-activity-message" }
const _hoisted_20 = {
  key: 0,
  class: "agent-activity-meta"
}
const _hoisted_21 = { class: "d-flex align-center gap-2" }
const _hoisted_22 = {
  key: 0,
  class: "reasoning-streaming-dot"
}
const _hoisted_23 = { class: "admin-reasoning-content" }
const _hoisted_24 = {
  key: 2,
  class: "learning-notice learning-error"
}
const _hoisted_25 = {
  key: 3,
  class: "typing-animation"
}
const _hoisted_26 = ["id"]
const _hoisted_27 = ["id", "innerHTML"]
const _hoisted_28 = {
  key: 6,
  class: "learning-next-action"
}
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { key: 2 }
const _hoisted_32 = {
  key: 7,
  class: "chat-input-attachments d-flex flex-column gap-1 mb-2"
}
const _hoisted_33 = ["src"]
const _hoisted_34 = {
  key: 1,
  class: "chat-input-attachment-container"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "pr-2" }
const _hoisted_37 = { class: "d-flex flex-column" }
const _hoisted_38 = { class: "font-weight-bold chat-input-attachment-title" }
const _hoisted_39 = { class: "chat-input-attachment-ext" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "message-sources-icon" }
const _hoisted_42 = { class: "message-sources-count" }
const _hoisted_43 = ["id"]
const _hoisted_44 = ["data-message-id"]
const _hoisted_45 = { class: "chat-content" }
const _hoisted_46 = { class: "chat-details" }
const _hoisted_47 = ["src"]
const _hoisted_48 = {
  key: 0,
  class: "chat-input-attachments d-flex flex-column gap-1 mb-2"
}
const _hoisted_49 = ["src"]
const _hoisted_50 = {
  key: 1,
  class: "chat-input-attachment-container"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "pr-2" }
const _hoisted_53 = { class: "d-flex flex-column" }
const _hoisted_54 = { class: "font-weight-bold chat-input-attachment-title" }
const _hoisted_55 = { class: "chat-input-attachment-ext" }
const _hoisted_56 = {
  key: 0,
  class: "learning-suggestions",
  "aria-label": "会話のきっかけ"
}
const _hoisted_57 = ["disabled"]
const _hoisted_58 = ["disabled"]
const _hoisted_59 = ["disabled", "onClick"]
const _hoisted_60 = {
  key: 1,
  class: "suggestion-question-list"
}
const _hoisted_61 = {
  key: 0,
  class: "d-flex justify-center"
}
const _hoisted_62 = { class: "suggestion-question-icon" }
const _hoisted_63 = ["src"]
const _hoisted_64 = { class: "suggestion-question-title" }
const _hoisted_65 = { class: "suggestion-question-icon" }
const _hoisted_66 = ["src"]
const _hoisted_67 = { class: "suggestion-question-title" }
const _hoisted_68 = {
  key: 1,
  class: "d-flex justify-center"
}
const _hoisted_69 = { class: "suggestion-question-icon" }
const _hoisted_70 = ["src"]
const _hoisted_71 = { class: "suggestion-question-title" }
const _hoisted_72 = { class: "suggestion-question-icon" }
const _hoisted_73 = ["src"]
const _hoisted_74 = { class: "suggestion-question-title" }
const _hoisted_75 = ["aria-label"]
const _hoisted_76 = {
  key: 3,
  class: "chat-connection-notice",
  role: "status"
}
const _hoisted_77 = { class: "chat-input-wrapper w-full ps-3 pe-3" }
const _hoisted_78 = {
  key: 0,
  class: "learning-notice",
  role: "status"
}
const _hoisted_79 = {
  key: 1,
  class: "learning-notice",
  role: "status"
}
const _hoisted_80 = {
  key: 2,
  class: "learning-notice learning-error",
  role: "alert"
}
const _hoisted_81 = ["disabled"]
const _hoisted_82 = {
  key: 3,
  class: "learning-notice learning-error",
  role: "alert"
}
const _hoisted_83 = {
  key: 4,
  class: "learning-notice learning-error",
  role: "alert"
}
const _hoisted_84 = {
  key: 5,
  class: "chat-input-attachments-wrapper mb-2"
}
const _hoisted_85 = { class: "chat-input-attachments d-flex flex-column gap-2" }
const _hoisted_86 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass(`chat-input-attachment-container`)
}
const _hoisted_87 = { class: "chat-input-attachment d-flex" }
const _hoisted_88 = { class: "pr-2" }
const _hoisted_89 = { class: "d-flex flex-column" }
const _hoisted_90 = { class: "font-weight-bold chat-input-attachment-title" }
const _hoisted_91 = { class: "chat-input-attachment-ext" }
const _hoisted_92 = { class: "chat-input-remove-icon" }
const _hoisted_93 = { class: "chat-composer-area" }
const _hoisted_94 = {
  key: 0,
  class: "chat-limit-notice limit-reached",
  role: "status"
}
const _hoisted_95 = {
  key: 1,
  class: "chat-limit-notice",
  role: "status"
}
const _hoisted_96 = {
  key: 0,
  href: "/premium_services",
  target: "_blank"
}
const _hoisted_97 = {
  key: 2,
  class: "chat-limit-notice",
  role: "status"
}
const _hoisted_98 = ["placeholder", "disabled"]
const _hoisted_99 = { class: "chat-composer-bar" }
const _hoisted_100 = ["value"]
const _hoisted_101 = {
  class: "learning-menu-options",
  "aria-label": "学習の操作"
}
const _hoisted_102 = ["disabled"]
const _hoisted_103 = ["disabled"]
const _hoisted_104 = ["disabled"]
const _hoisted_105 = ["disabled"]
const _hoisted_106 = {
  key: 3,
  class: "learning-mode"
}
const _hoisted_107 = ["disabled"]
const _hoisted_108 = ["title"]
const _hoisted_109 = ["title"]
const _hoisted_110 = { class: "chat-input-backdrop" }
const _hoisted_111 = { class: "source-section-title" }
const _hoisted_112 = ["href"]
const _hoisted_113 = { key: 1 }
const _hoisted_114 = {
  key: 2,
  class: "source-meta"
}
const _hoisted_115 = {
  key: 0,
  class: "text-muted"
}

import { ref, computed, watch, onMounted, onUpdated, onBeforeUnmount, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Message from '../../../api/v2/models/message'
import api from '../../../api/v2/api'
import { makeChannel } from '../../../../action_cable/cable'
import MessageForm from '../../../api/v2/forms/message'
import ThreadForm from '../../../api/v2/forms/thread'
import FileIcon from '../atoms_molecules/FileIcon.vue'
import AttachmentForm from "../../../api/v2/forms/attachment"
import Axios from "axios"
import LessonPracticeApi from '../../../api/v2/api/lesson_practice'
import type { ClassroomView } from '../../composables/useClassroomPractice'
import { useLessonPractice } from '../../composables/useLessonPractice'
import AiChatQuestion from "../../../api/v2/models/ai_chat_question"
import url_path from "../../../../helpers/url_helper"
import { checkMobile } from '../../utils/utils'
import { getQueryString } from '../../../../helpers/route-helper'
type ScrollAnchor = { id: number; offset: number }

export default /*@__PURE__*/_defineComponent({
  __name: 'MesageContainer',
  props: {
    targetableType: { default: 'Lesson' },
    targetableId: {},
    toggleCreateThreadBtn: {},
    usingDeepseek: { type: Boolean, default: false },
    showComponent: { type: Boolean, default: true },
    isDashboard: { type: Boolean, default: false },
    practiceEnabled: { type: Boolean, default: false },
    courseId: {},
    activeView: {},
    practiceDiscussion: {},
    hasSidebarBanner: { type: Boolean, default: false }
  },
  emits: ["practice-created", "practice-generating", "practice-progress"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const logoBot = require("../../../../images/bot.png").default
const logo = require("../../../../images/edbase_logo.gif").default

// Props
const props = __props

const practiceEmit = __emit
const route = useRoute()
const router = useRouter()

// Refs
const chatContainer = ref<HTMLElement | null>(null)
const chatInput = ref<HTMLTextAreaElement | null>(null)
const speechMedia = ref<HTMLAudioElement | null>(null)
const file = ref<HTMLInputElement | null>(null)

// State
const messages = ref<Message[]>([])
const chatContent = ref('')
const threadId = ref('')
const limitMessage = ref(100)
const messageCount = ref(0)
const showCountLimitMessage = ref(false)
const chanel = ref<any>(null)
const attachments = ref<any[]>([])
const isDragging = ref(false)
const codeDialog = ref(false)
const dialogHTML = ref('')
const inProgress = ref(false)
const aiChatQuestions = ref<AiChatQuestion[]>([])
const autoFollow = ref(false)
const turnSpacerActive = ref(false)
const threadAnchors = new Map<string, ScrollAnchor>()
const threadDrafts = new Map<string, { content: string; attachments: any[]; pending: MessageForm | null }>()
let visibleAnchor: ScrollAnchor | null = null
let lastRenderedThread = ''
let lastDraftKey = ''
let programmaticScroll = false
let pendingTurnMessageId: number | null = null
const scrollAnimationFrame = ref<number | null>(null)
const resizeObserver = ref<any>(null)
const resizeThrottleTimer = ref<any>(null)
const containerLoadHandler = ref<any>(null)
const chatScrollHandler = ref<any>(null)
const generationRecoveryTimer = ref<any>(null)
const generationRecoveryActive = ref(false)
const generationRecoveryGeneration = ref(0)
const generationRecoveryAttempt = ref(0)
const connectionNotice = ref('')
const chatSendError = ref('')
const pendingSendForm = ref<MessageForm | null>(null)
const bannerObserver = ref<any>(null)
const availableAgents = ref<any[]>([])
const selectedAgentId = ref<number | null>(null)
const welcomeMessage = ref('こんにちは、今日も頑張りましょう！質問を入力して会話を始めましょう。')
const initialScrollDone = ref(false)
const streamingContent = ref<{ [key: number]: string }>({})
const practicePartialContent = ref<{ [key: number]: string }>({})
const practiceEventSequence = new Map<number, { version: number; sequence: number }>()
const streamingReasoningContent = ref<{ [key: number]: string }>({})
const liveAgentActivities = ref<{ [key: number]: any[] }>({})
const sourceDialog = ref(false)
const activeSourceMessage = ref<Message | null>(null)

// Computed
const threadIdQuery = computed(() => getQueryString(route.query, 'thread_id'))
const targetableIdStr = computed(() => String(props.targetableId))
const nextDayFormatted = computed(() => {
  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(today.getDate() + 1)
  return `${tomorrow.getMonth() + 1}月${tomorrow.getDate()}日`
})
const selectedAgent = computed(() => availableAgents.value.find(agent => agent.id === selectedAgentId.value))
const hasAvailableAgent = computed(() => availableAgents.value.length > 0 && selectedAgentId.value !== null)
const modelSupportsVision = computed(() => selectedAgent.value?.supportsVision ?? false)
const shouldShowSuggestionQuestions = computed(() => messages.value.length === 0)
const activeAttachments = computed(() => attachments.value.filter(attachment => !attachment.isDeleted))

// Methods
const getDisplayContent = (message: Message) => streamingContent.value[message.id] || message.content || ''
const hasReasoningContent = (message: Message) => {
  const streaming = streamingReasoningContent.value[message.id]
  return !!(streaming && streaming.trim()) || !!(message.reasoningContent && message.reasoningContent.trim())
}

const activityLabel = (activity: any) => {
  const labels: Record<string, string> = {
    search_courses: 'コースを検索しました',
    search_lessons: 'レッスンを検索しました',
    get_lesson: 'レッスンを確認しました',
    get_lesson_in_course: 'レッスンを確認しました',
    search_sources: '登録リソースを確認しました',
    web_search: 'Webを検索しました',
    search_learning_history: '学習履歴を確認しました',
    get_user_weaknesses: '弱点データを分析しました',
    check_learning_progress: '学習進捗を確認しました',
  }
  return labels[activity.tool] || `${activity.tool || '処理'}を実行しました`
}

const activityDisplayMessage = (activity: any) => {
  if (!activity.message) return activityLabel(activity)
  if (activityState(activity) === 'running' || !activity.tool) return activity.message
  return activity.message
    .replace(/検索しています\.\.\.$/, '検索しました')
    .replace(/読んでいます\.\.\.$/, '読みました')
    .replace(/確認しています\.\.\.$/, '確認しました')
    .replace(/分析しています\.\.\.$/, '分析しました')
    .replace(/実行しています\.\.\.$/, '実行しました')
}

const agentActivitiesFor = (message: any) => {
  if (message.learningDialog?.status === 'cancelled') return []
  const live = liveAgentActivities.value[message.id]
  if (Array.isArray(live) && live.length > 0) return live
  const stored = Array.isArray(message.agentActivities) ? message.agentActivities : []
  return stored.length > 0 ? [...stored, { kind: 'drafting', message: '回答を作成しました', state: 'done' }] : []
}

const activityState = (activity: any) => activity.state || (activity.error ? 'error' : 'done')
const completedActivityCount = (message: any) => agentActivitiesFor(message).filter((activity: any) => activityState(activity) !== 'running').length
const activityMeta = (activity: any) => {
  const meta: string[] = []
  if (activity.resultCount !== undefined && activity.resultCount !== null) meta.push(`${activity.resultCount}件`)
  if (activity.durationMs !== undefined && activity.durationMs !== null) meta.push(activity.durationMs >= 1000 ? `${(activity.durationMs / 1000).toFixed(1)}秒` : `${activity.durationMs}ms`)
  if (activity.cached) meta.push('キャッシュ')
  if (activity.error) meta.push(activity.error)
  return meta.join(' ・ ')
}

const setLiveActivities = (messageId: number, activities: any[]) => {
  liveAgentActivities.value = { ...liveAgentActivities.value, [messageId]: activities }
}

const completeRunningActivities = (messageId: number, kind?: string) => {
  const activities = [...(liveAgentActivities.value[messageId] || [])]
  for (let i = activities.length - 1; i >= 0; i -= 1) {
    if (activities[i].state === 'running' && (!kind || activities[i].kind === kind)) {
      activities[i] = { ...activities[i], state: 'done' }
      if (kind) break
    }
  }
  setLiveActivities(messageId, activities)
}

const showInitialPreparing = (messageId: number) => {
  if (liveAgentActivities.value[messageId]?.length) return
  setLiveActivities(messageId, [{ kind: 'preparing', message: '回答に必要な情報を準備しています…', state: 'running' }])
}

const recordLiveStatus = (event: any) => {
  const messageId = Number(event.message_id)
  if (!messageId) return

  if (event.status === 'practice_preparing') {
    showInitialPreparing(messageId)
    return
  }

  if (event.status === 'tool_running') {
    completeRunningActivities(messageId)
    const activities = [...(liveAgentActivities.value[messageId] || [])]
    activities.push({ kind: 'tool', message: event.status_message || '情報を確認しています…', state: 'running' })
    setLiveActivities(messageId, activities)
    return
  }

  if (event.status === 'tool_done') {
    completeRunningActivities(messageId, 'tool')
    return
  }

  if (event.status === 'drafting') {
    const activities = [...(liveAgentActivities.value[messageId] || [])]
    const lastActivity = activities[activities.length - 1]
    if (lastActivity?.kind === 'drafting' && lastActivity.state === 'running') {
      lastActivity.message = '回答を作成しています…'
      setLiveActivities(messageId, activities)
      return
    }
    completeRunningActivities(messageId)
    const nextActivities = [...(liveAgentActivities.value[messageId] || [])]
    nextActivities.push({ kind: 'drafting', message: '回答を作成しています…', state: 'running' })
    setLiveActivities(messageId, nextActivities)
  }
}

const getAgentAvatar = (message: any) => {
  if (message.isBot && message.agentId) {
    const agent = availableAgents.value.find(a => a.id === message.agentId)
    return (agent && agent.imageUrl) || logoBot
  }
  return logoBot
}

const scheduleScrollToLast = (behavior: ScrollBehavior = 'auto', force = false) => {
  if (!force && !autoFollow.value) return
  if (force) autoFollow.value = true
  if (scrollAnimationFrame.value !== null) cancelAnimationFrame(scrollAnimationFrame.value)
  scrollAnimationFrame.value = requestAnimationFrame(() => {
    programmaticScroll = true
    chatContainer.value?.scrollTo({ top: chatContainer.value.scrollHeight, behavior })
    requestAnimationFrame(() => { programmaticScroll = false })
    scrollAnimationFrame.value = null
  })
}

const scrollToLast = () => scheduleScrollToLast('auto')
const scrollToLastImm = () => scheduleScrollToLast('auto')
const resumeAutoFollow = () => { turnSpacerActive.value = false; nextTick(() => scheduleScrollToLast('smooth', true)) }
const captureVisibleAnchor = (): ScrollAnchor | null => {
  const container = chatContainer.value
  if (!container) return null
  const top = container.getBoundingClientRect().top
  const item = Array.from(container.querySelectorAll<HTMLElement>('[data-message-id]'))
    .find(el => el.getBoundingClientRect().bottom > top + 8)
  return item ? { id: Number(item.dataset.messageId), offset: item.getBoundingClientRect().top - top } : null
}
const restoreVisibleAnchor = (anchor: ScrollAnchor | null) => {
  const container = chatContainer.value
  const item = container?.querySelector<HTMLElement>(`[data-message-id="${anchor?.id}"]`)
  if (!container || !item || !anchor) return
  programmaticScroll = true
  container.scrollTop += item.getBoundingClientRect().top - container.getBoundingClientRect().top - anchor.offset
  requestAnimationFrame(() => { programmaticScroll = false })
}
const scrollToMessageStart = (id: number) => {
  const container = chatContainer.value
  const item = container?.querySelector<HTMLElement>(`[data-message-id="${id}"]`)
  if (!container || !item) return
  programmaticScroll = true
  container.scrollTop += item.getBoundingClientRect().top - container.getBoundingClientRect().top - 12
  visibleAnchor = captureVisibleAnchor()
  requestAnimationFrame(() => { programmaticScroll = false })
}
// 下に読んでいない部分があるか（ボタンを出すかどうか）と、最新の回答の冒頭がまだ下にあるか
const hiddenBelow = ref(false)
const latestAnswerBelow = ref(false)
const latestBotMessage = () => [...messages.value].reverse().find(message => message.isBot) || messages.value[messages.value.length - 1]
const updateScrollHints = () => {
  const container = chatContainer.value
  if (!container) return
  hiddenBelow.value = container.scrollHeight - container.scrollTop - container.clientHeight > 80
  const latest = latestBotMessage()
  const item = latest && container.querySelector<HTMLElement>(`[data-message-id="${latest.id}"]`)
  latestAnswerBelow.value = !!item && item.getBoundingClientRect().top > container.getBoundingClientRect().bottom - 40
}
const scrollDownOnce = () => {
  const latest = latestBotMessage()
  if (latestAnswerBelow.value && latest) {
    autoFollow.value = false
    scrollToMessageStart(latest.id)
  } else {
    resumeAutoFollow()
  }
  nextTick(() => requestAnimationFrame(updateScrollHints))
}
const showLatestAnswer = () => {
  autoFollow.value = false
  const latest = [...messages.value].reverse().find(message => message.isBot) || messages.value[messages.value.length - 1]
  if (latest) scrollToMessageStart(latest.id)
}

const stopGenerationRecovery = () => {
  generationRecoveryGeneration.value += 1
  generationRecoveryActive.value = false
  generationRecoveryAttempt.value = 0
  if (generationRecoveryTimer.value) clearTimeout(generationRecoveryTimer.value)
  generationRecoveryTimer.value = null
}

const latestBotIsPending = (items = messages.value) => {
  const latestBot = [...items].reverse().find(message => message.isBot)
  if (!latestBot || String(latestBot.content || '').trim()) return false
  if (latestBot.generationState) return ['queued', 'running', 'generating'].includes(latestBot.generationState)
  const createdAt = new Date(latestBot.created_at).getTime()
  return Number.isFinite(createdAt) && Date.now() - createdAt < 5 * 60 * 1000
}

const currentThreadId = () => String(threadIdQuery.value || threadId.value || '')

const reconcileGeneration = async (generation?: number) => {
  const tid = threadIdQuery.value || threadId.value
  const target = targetableIdStr.value
  const result = await api.message.index({ targetableId: targetableIdStr.value, targetableType: props.targetableType, threadId: tid, courseId: props.courseId })
  if (String(tid || '') !== currentThreadId()) return false
  if (generation !== undefined && (generation !== generationRecoveryGeneration.value || !generationRecoveryActive.value)) return false
  messages.value = result[1]
  const pending = latestBotIsPending(result[1])
  inProgress.value = pending
  if (!pending) {
    stopGenerationRecovery()
    streamingContent.value = {}
    practicePartialContent.value = {}
    streamingReasoningContent.value = {}
    liveAgentActivities.value = {}
    connectionNotice.value = ''
  }
  return pending
}

const scheduleGenerationRecovery = (generation: number) => {
  if (!generationRecoveryActive.value || generation !== generationRecoveryGeneration.value) return
  if (generationRecoveryAttempt.value >= 10) {
    generationRecoveryActive.value = false
    connectionNotice.value = '回答の状態を確認できません。状態を読み直してください。'
    return
  }
  const delay = Math.min(3000 * 2 ** Math.floor(generationRecoveryAttempt.value / 2), 30000)
  generationRecoveryAttempt.value += 1
  generationRecoveryTimer.value = setTimeout(async () => {
    generationRecoveryTimer.value = null
    try {
      const pending = await reconcileGeneration(generation)
      if (pending && generationRecoveryActive.value && generation === generationRecoveryGeneration.value) {
        scheduleGenerationRecovery(generation)
      }
    } catch {
      if (!generationRecoveryActive.value || generation !== generationRecoveryGeneration.value) return
      connectionNotice.value = '接続を確認しています。回答は復旧後に自動で表示されます。'
      scheduleGenerationRecovery(generation)
    }
  }, delay)
}

const startGenerationRecovery = () => {
  if (generationRecoveryActive.value) return
  generationRecoveryActive.value = true
  generationRecoveryAttempt.value = 0
  const generation = ++generationRecoveryGeneration.value
  scheduleGenerationRecovery(generation)
}

const createChannel = () => {
  chanel.value = makeChannel('ChatLessonChannel', async (e) => {
    if (!e) return
    if (e.message_id && !messages.value.some(m => m.id === Number(e.message_id))) return
    if (e.thread_id && String(e.thread_id) !== currentThreadId()) return
    if (e.lesson_id && Number(e.lesson_id) !== Number(props.targetableId)) return
    if (e.course_id && props.courseId && Number(e.course_id) !== props.courseId) return
    const eventMessage = messages.value.find(m => m.id === Number(e.message_id))
    if (eventMessage?.learningDialog?.status === 'cancelled') return
    if (e.run_version !== undefined) {
      const version = Number(e.run_version)
      const previous = practiceEventSequence.get(Number(e.message_id))
      if (version < (eventMessage?.learningDialog?.runVersion || 0) || (previous && version < previous.version)) return
      if (previous && version === previous.version && e.sequence !== undefined && Number(e.sequence) <= previous.sequence) return
      practiceEventSequence.set(Number(e.message_id), { version, sequence: Number(e.sequence || previous?.sequence || 0) })
    }
    if (e.status === 'practice_reset') {
      practicePartialContent.value = { ...practicePartialContent.value, [e.message_id]: '' }
      return
    }
    if (e.status === 'practice_partial') {
      practicePartialContent.value = { ...practicePartialContent.value, [e.message_id]: String(e.plain_content || '') }
      return
    }
    if (e.status) recordLiveStatus(e)
    if (e.finished || e.content == 'Finished') {
      inProgress.value = false
      stopGenerationRecovery()
      const finishedThreadId = currentThreadId()
      connectionNotice.value = ''
      completeRunningActivities(Number(e.message_id))
      try {
        const msg = await api.message.show(e.message_id)
        if (finishedThreadId !== currentThreadId()) return
        const idx = messages.value.findIndex(m => m.id === e.message_id)
        if (idx > -1) {
          delete streamingContent.value[e.message_id]
          delete practicePartialContent.value[e.message_id]
          delete streamingReasoningContent.value[e.message_id]
          const newMsgs = [...messages.value]
          newMsgs[idx] = msg
          messages.value = newMsgs
        } else {
          await reconcileGeneration()
        }
      } catch {
        reconcileGeneration().catch(() => {
          connectionNotice.value = '回答を取得できませんでした。通信状態を確認しています。'
        })
      }
      const nextLiveActivities = { ...liveAgentActivities.value }
      delete nextLiveActivities[e.message_id]
      liveAgentActivities.value = nextLiveActivities
    } else if (e.content == 'Stop finished') {
      inProgress.value = false
      stopGenerationRecovery()
      streamingContent.value = {}
      practicePartialContent.value = {}
      streamingReasoningContent.value = {}
      liveAgentActivities.value = {}
    } else {
      if (e.content) streamingContent.value = { ...streamingContent.value, [e.message_id]: e.content }
      if (e.reasoning_content) streamingReasoningContent.value = { ...streamingReasoningContent.value, [e.message_id]: e.reasoning_content }
    }
  }, () => {
    connectionNotice.value = ''
    chanel.value.send({ action: 'follow', data: { targetable_id: targetableIdStr.value, targetable_type: props.targetableType } })
    reconcileGeneration().catch(() => {})
  }, () => {
    if (inProgress.value) {
      connectionNotice.value = '接続が一時的に切れました。回答を再確認しています。'
      startGenerationRecovery()
    }
  }, () => {
    connectionNotice.value = 'リアルタイム接続を開始できませんでした。回答を再確認しています。'
    if (inProgress.value) startGenerationRecovery()
  })
}

const reconnectChannel = () => {
  if (chanel.value) { chanel.value.unsubscribe(); chanel.value = null }
  createChannel()
}

const apiErrorMessage = (error: any, fallback: string) => {
  const value = error?.baseResponse?.data?.message ?? error?.messages
  if (typeof value === 'string' && value.trim()) return value
  if (Array.isArray(value)) {
    const text = value.flat(Infinity).filter((item: unknown) => typeof item === 'string').join('、')
    if (text) return text
  }
  return fallback
}

const createMessage = async (options: { aiChatQuestionId?: any; content?: string } = {}) => {
  if (inProgress.value) return
  if (props.practiceEnabled && props.targetableType === 'Lesson' && dialogState.value?.status === 'asking') {
    await sendPracticeDialog('answer', options.content ?? chatContent.value)
    return
  }
  const typed = (options.content ?? chatContent.value).trim()
  if (isPracticeLesson.value && comprehensiveTrigger.value && !pendingSendForm.value && !options.aiChatQuestionId &&
      typed.includes(comprehensiveTrigger.value)) {
    if (learningActionDisabled.value || dialogActive.value) return
    chatContent.value = ''
    await startPractice('comprehensive')
    return
  }
  const input = chatInput.value
  const form = pendingSendForm.value || new MessageForm()
  if (!pendingSendForm.value) {
    form.content = (options.content ?? chatContent.value).trim()
    form.targetableId = parseInt(String(props.targetableId))
    form.targetableType = props.targetableType
    form.attachmentIds = attachments.value.filter(a => !a.isDeleted && a.serverId).map(a => a.serverId)
    form.aiChatQuestionId = options.aiChatQuestionId
    form.activeView = props.activeView ? JSON.parse(JSON.stringify(props.activeView)) : undefined
    form.agentId = selectedAgentId.value
    form.threadId = currentThreadId()
    form.courseId = props.courseId
    if (props.targetableType === 'Lesson') form.clientRequestId = crypto.randomUUID()
    pendingSendForm.value = form
  }
  chatSendError.value = ''
  connectionNotice.value = ''
  inProgress.value = true
  let accepted = false
  try {
    const msg = await api.message.create(form)
    accepted = true
    pendingSendForm.value = null
    turnSpacerActive.value = true
    pendingTurnMessageId = msg.id
    if (!threadId.value) threadId.value = msg.threadId
    if (chatContent.value.trim() === form.content) chatContent.value = ''
    attachments.value = attachments.value.filter(a => !form.attachmentIds.includes(a.serverId))
    input?.style.setProperty('height', 'unset')
    const result = await api.message.index({ targetableId: targetableIdStr.value, targetableType: props.targetableType, threadId: threadId.value, courseId: props.courseId })
    messages.value = result[1]
    if (props.toggleCreateThreadBtn) props.toggleCreateThreadBtn(!!messages.value.length)
    messageCount.value = result[0].totalMessage
    limitMessage.value = result[0].limitMessage
    showCountLimitMessage.value = result[0].showCountLimitMessage
    nextTick(() => {
      try {
        const latestBot = [...messages.value].reverse().find(m => (m as any).isBot && (!m.content || String(m.content).trim() === ''))
        if (latestBot?.id) showInitialPreparing(latestBot.id)
      } catch {}
    })
    startGenerationRecovery()
  } catch (e) {
    if (accepted) {
      connectionNotice.value = '送信は受け付けました。回答の状態を読み直してください。'
      startGenerationRecovery()
    } else {
      inProgress.value = false
      const status = (e as any)?.baseResponse?.data?.status
      if (status && status !== '001') pendingSendForm.value = null
      chatSendError.value = apiErrorMessage(e, '送信結果を確認できません。状態を読み直すか、同じ内容を再送してください。')
    }
  }
}

const changeRoute = async () => {
  if (lastRenderedThread && captureVisibleAnchor()) threadAnchors.set(lastRenderedThread, captureVisibleAnchor()!)
  if (lastDraftKey) threadDrafts.set(lastDraftKey, { content: chatContent.value, attachments: [...attachments.value], pending: pendingSendForm.value })
  stopStream()
  stopGenerationRecovery()
  inProgress.value = false
  turnSpacerActive.value = false
  initialScrollDone.value = false
  streamingContent.value = {}
  practicePartialContent.value = {}
  streamingReasoningContent.value = {}
  liveAgentActivities.value = {}
  const tid = threadIdQuery.value || ''
  threadId.value = tid
  const result = await api.message.index({ targetableId: targetableIdStr.value, targetableType: props.targetableType, threadId: tid, courseId: props.courseId })
  if (String(tid) !== currentThreadId()) return
  // URLの会話IDが別のレッスンのもの（レッスン切り替え後など）なら、サーバーが選んだこのレッスンの会話に合わせる
  const serverThreadId = result[0]?.threadId ? String(result[0].threadId) : ''
  if (serverThreadId && serverThreadId !== String(tid)) {
    threadId.value = serverThreadId
    router.replace({ query: { ...route.query, thread_id: serverThreadId } }).catch(e => { if (e.name != 'NavigationDuplicated') throw e })
    return
  }
  messages.value = result[1]
  if (props.toggleCreateThreadBtn) props.toggleCreateThreadBtn(!!messages.value.length)
  messageCount.value = result[0].totalMessage
  limitMessage.value = result[0].limitMessage
  showCountLimitMessage.value = result[0].showCountLimitMessage
  const draftKey = `${props.targetableType}:${props.targetableId}:${tid}`
  const draft = threadDrafts.get(draftKey)
  chatContent.value = draft?.content || ''
  attachments.value = draft?.attachments || []
  pendingSendForm.value = draft?.pending || null
  lastDraftKey = draftKey
  inProgress.value = latestBotIsPending()
  if (inProgress.value) startGenerationRecovery()
}

const clearMessage = async () => { try { messages.value = await api.message.clear({ targetableId: targetableIdStr.value, targetableType: props.targetableType }) } catch {} }
const stopGenerate = async () => {
  try {
    stopStream()
    messages.value = await api.message.stopGenerate({ targetableId: targetableIdStr.value, targetableType: props.targetableType })
  } catch {
    connectionNotice.value = '生成の停止を確認できませんでした。'
  } finally {
    inProgress.value = false
    stopGenerationRecovery()
  }
}

const createThread = async () => {
  try {
    const form = new ThreadForm()
    form.targetableId = parseInt(String(props.targetableId))
    form.targetableType = props.targetableType
    const thread = await api.thread.create(form)
    await router.push({ query: { ...route.query, thread_id: thread.id.toString() } })
  } catch {
    connectionNotice.value = '新規スレッドを作成できませんでした。もう一度お試しください。'
  }
}

const refresh = async () => {
  const tid = threadIdQuery.value || threadId.value
  const target = targetableIdStr.value
  const result = await api.message.index({ targetableId: targetableIdStr.value, targetableType: props.targetableType, threadId: tid, courseId: props.courseId })
  if (String(tid) !== currentThreadId() || target !== targetableIdStr.value) return
  messages.value = result[1]
  const meta = result[0] || {}
  if (meta.threadId && String(meta.threadId) !== String(threadIdQuery.value || '')) {
    threadId.value = String(meta.threadId)
    router.replace({ query: { ...route.query, thread_id: String(meta.threadId) } }).catch(e => { if (e.name != 'NavigationDuplicated') throw e })
  }
  if (props.toggleCreateThreadBtn) props.toggleCreateThreadBtn(!!messages.value.length)
  messageCount.value = meta.totalMessage
  limitMessage.value = meta.limitMessage
  showCountLimitMessage.value = meta.showCountLimitMessage
  inProgress.value = latestBotIsPending()
  if (inProgress.value) startGenerationRecovery()
  else stopGenerationRecovery()
}

let composerObserver: ResizeObserver | null = null
let dashboardModal: HTMLElement | null = null
const remeasureDashboardHeight = () => autoExpandTextarea()
const autoExpandTextarea = () => {
  const textarea = document.getElementById('chat-input') as HTMLTextAreaElement
  if (!textarea) return
  textarea.setAttribute('style', 'height: auto !important')
  const newHeight = textarea.scrollHeight + 2
  let maxHeight = props.isDashboard ? 120 : 200
  if (props.isDashboard) {
    const container = document.getElementById('chat-container')
    if (container) {
      const textareaHeight = Math.min(newHeight, maxHeight)
      // 会話の欄の高さ＝画面 −（会話の欄より上）−（入力欄まわり）。入力欄まわりの高さは決め打ちにせず、実際の高さを測る
      // （回数の案内・添付・先生の選択の有無で変わる。決め打ちだと、入力欄の下に余白が出たり、画面の下に切れたりする）
      const root = container.parentElement
      const area = root?.querySelector<HTMLElement>('.chat-composer-area')
      const notices = root?.querySelector<HTMLElement>('.chat-input-wrapper')
      // 画面内での位置で測る（ページのスクロール量は足さない）。スマホのダッシュボードは position: fixed のモーダルの中で、
      // 背景のページを下へスクロールしてから開くと、足した分だけ会話の欄が短くなる。100vh から引く値は画面内の座標で揃える
      const top = container.getBoundingClientRect().top
      const visible = container.getClientRects().length > 0 && !!area
      if (visible) {
        const composer = area!.offsetHeight - textarea.offsetHeight + textareaHeight
        const margin = checkMobile() ? 16 : 8
        const used = Math.round(top + composer + (notices?.offsetHeight || 0) + margin)
        container.style.height = `calc(${checkMobile() ? '100dvh' : '100vh'} - ${used}px)`
      }
    }
  }
  textarea.setAttribute('style', `height: ${Math.min(newHeight, maxHeight)}px !important; overflow-y: ${newHeight > maxHeight ? 'auto' : 'hidden'} !important;`)
}

const handleFileChange = () => {
  if (!file.value?.files) return
  Array.from(file.value.files).forEach(f => {
    if (attachments.value.find(a => !a.isDeleted && a.file.name === f.name && a.file.size === f.size)) return
    const attachment = { isDeleted: false, isUploadCompleted: false, serverId: null, progressPercentage: 5, file: f }
    if (/png|jpeg|jpg/.test(f.type) && 10 * 1024 * 1024 < f.size) { alert("Limit 10 MB per image."); return }
    if (/png|jpeg|jpg/.test(f.type)) { attachments.value.push(attachment); handleUpload(attachment) }
  })
  file.value.value = ''
}

const dragover = (e: DragEvent) => { if (!modelSupportsVision.value) return; e.preventDefault(); isDragging.value = true }
const dragleave = () => { if (!modelSupportsVision.value) return; isDragging.value = false }
const drop = (e: DragEvent) => { if (!modelSupportsVision.value) return; if (file.value) file.value.files = e.dataTransfer?.files || null; handleFileChange(); isDragging.value = false; e.preventDefault() }

const getFileName = (attachment: any) => attachment.file.name.replace(/\.[^/.]+$/, "")
const getFileExt = (attachment: any) => attachment.file.name.split('.').pop().toUpperCase()
const getFileNameFromString = (str: string) => str.replace(/\.[^/.]+$/, "")
const getFileExtFromString = (str: string) => str.split('.').pop()?.toUpperCase() || ""
const addAttachment = () => file.value?.click()
const deleteAttachment = (index: number) => { attachments.value[index].isDeleted = true }
const openUrl = (url: string) => window.open(url, "_blank")
const canSubmit = () => (chatContent.value.trim() != "" || attachments.value.filter(a => !a.isDeleted && a.isUploadCompleted).length) && messageCount.value < limitMessage.value && hasAvailableAgent.value

const handleUpload = async (attachment: any) => {
  const form = new AttachmentForm()
  form.filename = attachment.file.name
  const res = await api.attachment.create(form)
  const parseProgress = (e: any) => { const p = (e.loaded / e.total) * 100; attachment.progressPercentage = p > 98 ? 98 : p > 5 ? p : 5 }
  const r = await Axios.put(res.uploadUrl, attachment.file, { headers: { 'Content-Type': attachment.file.type, 'Content-Disposition': `attachment; filename=${attachment.file.name}` }, onUploadProgress: parseProgress })
  if (r.status === 200) { attachment.isUploadCompleted = true; attachment.serverId = res.id } else alert("Error: Upload failed!")
}

const handleCopy = (e: any) => {
  if (e.target.classList.contains("highlight-copy-btn")) {
    navigator.clipboard.writeText(e.target.closest(".highlight-container").querySelector("code").innerText)
    e.target.querySelector(".action-name").innerText = "コピーしました！"
    setTimeout(() => e.target.querySelector(".action-name").innerText = "コードをコピーする", 1000)
  }
}

const handleZoomHighlight = (e: any) => { if (e.target.classList.contains("highlight-zoom-btn")) { dialogHTML.value = e.target.closest(".highlight-container").outerHTML; codeDialog.value = true } }
const handleZoomImage = (e: any) => { if (e.target.classList.contains("message-attachment-image")) { dialogHTML.value = e.target.outerHTML; codeDialog.value = true } }
const handleEnterChatForm = (e: KeyboardEvent) => { if (e.key === 'Enter' && !e.shiftKey && !e.isComposing && e.keyCode !== 229) { e.preventDefault(); if (canSubmit()) createMessage(); return false } }
const copyMessage = (index: number) => navigator.clipboard.writeText(messages.value[index].contentRaw)

const normalizedSources = (message: any) => {
  const value = message?.citedSources || message?.cited_sources || {}
  return {
    cited: Array.isArray(value.cited) ? value.cited : [],
    related: Array.isArray(value.related) ? value.related : [],
  }
}

const sourceCount = (message: any) => normalizedSources(message).cited.length
const openSources = (message: Message) => { activeSourceMessage.value = message; sourceDialog.value = true }
const sourceKey = (source: any) => `${source.kind || 'source'}-${source.lessonId || source.courseId || source.premiumServiceId || source.blogId || source.manualArticleId || source.aiTutorSourceId || source.aiTutorQaSourceId || source.url || source.title}`

const sourceSections = (message: any) => {
  const sources = normalizedSources(message)
  const sections = [
    { key: 'lesson', title: 'コース・レッスン', icon: 'mdi-school', sources: sources.cited.filter((s: any) => s.kind === 'lesson') },
    { key: 'source', title: '登録リソース', icon: 'mdi-file-document-outline', sources: sources.cited.filter((s: any) => s.kind === 'source') },
    { key: 'faq', title: 'FAQ', icon: 'mdi-help-circle-outline', sources: sources.cited.filter((s: any) => s.kind === 'faq') },
    { key: 'web', title: 'Web検索', icon: 'mdi-magnify', sources: sources.cited.filter((s: any) => s.kind === 'web') },
    { key: 'guide', title: 'コース・プラン・記事', icon: 'mdi-compass-outline', sources: sources.cited.filter((s: any) => ['course', 'plan', 'blog', 'manual'].includes(s.kind)) },
    { key: 'related', title: '関連コース・レッスン', icon: 'mdi-link-variant', sources: sources.related },
  ]
  return sections.filter(section => section.sources.length > 0)
}

const copyAllSources = (message: any) => {
  const lines = sourceSections(message).flatMap(section => {
    return [
      section.title,
      ...section.sources.map((source: any) => source.url ? `${source.title || source.url} ${source.url}` : `${source.title}`),
    ]
  })
  navigator.clipboard.writeText(lines.join("\n"))
}

const regenerate = async (index: number) => {
  stopStream()
  await api.message.regenerate(messages.value[index].id)
  threadId.value = threadIdQuery.value ? String(threadIdQuery.value) : threadId.value
  const result = await api.message.index({ targetableId: targetableIdStr.value, targetableType: props.targetableType, threadId: threadId.value, courseId: props.courseId })
  if (String(tid) !== currentThreadId() || target !== targetableIdStr.value) return
  messages.value = result[1]
  const meta = result[0] || {}
  if (!threadIdQuery.value && meta.threadId) { threadId.value = String(meta.threadId); router.replace({ query: { ...route.query, thread_id: String(meta.threadId) } }).catch(e => { if (e.name != 'NavigationDuplicated') throw e }) }
  if (props.toggleCreateThreadBtn) props.toggleCreateThreadBtn(!!messages.value.length)
  messageCount.value = meta.totalMessage
  limitMessage.value = meta.limitMessage
  showCountLimitMessage.value = meta.showCountLimitMessage
}

const speech = async (index: number) => {
  stopStream()
  const msg = messages.value[index]
  msg.speechPlaying = true
  try {
    if (!msg.cachedSpeechUrl) { const data = await api.message.speech(msg.id); msg.cachedSpeechUrl = data.data.url }
    if (speechMedia.value) { speechMedia.value.setAttribute("src", msg.cachedSpeechUrl); speechMedia.value.addEventListener("ended", () => { msg.speechPlaying = false }); await speechMedia.value.play() }
  } catch (e) { msg.speechPlaying = false; console.error('Error streaming audio:', e) }
}

const stopStream = () => {
  if (speechMedia.value) { try { speechMedia.value.pause() } catch {} messages.value.forEach(m => { m.speechPlaying = false }) }
}

const chatQuestionContext = () => { switch (props.targetableType) { case "Lesson": return ["lesson"]; case "Exam": case "Question": return ["question"]; case "UserGoal": return ["goal"]; case "School": return ["dashboard"]; default: return [] } }
const sendSuggestQuestion = (q: AiChatQuestion) => { if (inProgress.value) return; createMessage({ aiChatQuestionId: q.id }) }

const practiceApi = new LessonPracticeApi()
const practiceSettings = ref<import('../../../api/v2/api/lesson_practice').PracticeSettings | null>(null)
const practiceSettingsError = ref('')
const userSelectedAgent = ref(false)
function choosePracticeDefaultAgent() {
  const id = practiceSettings.value?.defaultAgentId
  if (!userSelectedAgent.value && id && availableAgents.value.some(agent => agent.id === id)) selectedAgentId.value = id
}
async function loadPracticeSettings() {
  if (!props.practiceEnabled || !props.courseId) return
  const lesson = Number(props.targetableId), course = props.courseId
  practiceSettings.value = null
  try {
    const settings = await practiceApi.settings(lesson, course)
    if (lesson === Number(props.targetableId) && course === props.courseId) { practiceSettings.value = settings; practiceSettingsError.value = ''; choosePracticeDefaultAgent() }
  } catch {
    if (lesson === Number(props.targetableId) && course === props.courseId) practiceSettingsError.value = '学習ボタンの設定を取得できません。再読み込みしてください。'
  }
}
watch(() => [props.targetableId, props.courseId], loadPracticeSettings, { immediate: true })
const { practiceBusy, practiceWaiting, practiceError, practiceFocus, createPractice, resumePractice } = useLessonPractice({
  lessonId: () => Number(props.targetableId),
  threadId: () => currentThreadId(),
  courseId: () => props.courseId || 0,
  fingerprint: mode => mode === 'focused' ? (dialogState.value?.focusedFingerprint || '') : (practiceSettings.value?.fingerprints[mode] || ''),
  api: practiceApi,
  agentId: () => selectedAgentId.value,
  onStale: loadPracticeSettings,
  onGenerating: value => practiceEmit('practice-generating', value),
  onProgress: value => practiceEmit('practice-progress', value),
  onReady: value => practiceEmit('practice-created', value)
})
async function refreshLearningState() {
  chatSendError.value = ''
  try {
    await Promise.all([refresh(), loadPracticeSettings()])
    const pending = pendingSendForm.value
    if (pending?.clientRequestId && messages.value.some(message => message.clientRequestId === pending.clientRequestId)) {
      if (chatContent.value.trim() === pending.content) chatContent.value = ''
      attachments.value = attachments.value.filter(a => !pending.attachmentIds.includes(a.serverId))
      pendingSendForm.value = null
      connectionNotice.value = ''
    }
    await resumePractice()
  } catch (e: any) {
    chatSendError.value = apiErrorMessage(e, '状態を読み直せませんでした。通信を確認してください。')
  }
}
const activeViewLabel = computed(() => {
  const view = props.activeView
  if (!view || view.kind === 'lesson') return 'このレッスンの教材'
  if (view.kind === 'loading') return 'テストを準備中'
  if (view.phase === 'result') return '表示中のテスト結果'
  if (view.questionNumber) return `表示中の問題 ${view.questionNumber}${['feedback', 'review'].includes(view.phase || '') ? '・解答と解説' : ''}`
  return '表示中のテスト'
})
const dialogBusy = ref(false)
const learningMenu = ref<HTMLDetailsElement | null>(null)
const isPracticeLesson = computed(() => props.practiceEnabled && props.targetableType === 'Lesson')
const chatActionDisabled = computed(() => inProgress.value || dialogBusy.value || !selectedAgentId.value || messageCount.value >= limitMessage.value)
const learningActionDisabled = computed(() => chatActionDisabled.value || practiceBusy.value || !practiceSettings.value)
const checkHint = computed(() => practiceSettings.value?.check.style === 'interview' ? '質問に答えながら整理' : '会話で一つずつ確認')
const comprehensiveCount = computed(() => practiceSettings.value?.comprehensive.questionCount)
// コースの設定で「レッスンから出題」のボタンを隠せる。隠していても、チャットで決めた言葉（例：Qテスト）を送れば出題する
const showComprehensiveButton = computed(() => !!practiceSettings.value && practiceSettings.value.comprehensive.showButton !== false)
const comprehensiveTrigger = computed(() => practiceSettings.value?.comprehensive.chatTrigger?.trim() || '')
const lessonSuggestions = computed(() => aiChatQuestions.value.filter(q => !/^Lesson Title \d+$/i.test(q.title?.trim() || '')).slice(0, 4))
const lastPracticeMode = ref<'focused' | 'comprehensive'>('comprehensive')
function closeLearningMenu(focus = false) {
  if (!learningMenu.value) return
  learningMenu.value.open = false
  if (focus) learningMenu.value.querySelector('summary')?.focus()
}
function leaveLearningMenu(event: FocusEvent) {
  if (!learningMenu.value?.contains(event.relatedTarget as Node)) closeLearningMenu()
}
function closeLearningMenuOutside(event: Event) {
  if (!learningMenu.value?.contains(event.target as Node)) closeLearningMenu()
}
function startPractice(mode: 'focused' | 'comprehensive') {
  if (learningActionDisabled.value || dialogActive.value) return
  closeLearningMenu()
  lastPracticeMode.value = mode
  return createPractice(mode)
}
const latestDialogMessage = computed(() => [...messages.value].reverse().find(m => m.isBot && m.learningDialog))
const dialogState = computed(() => latestDialogMessage.value?.learningDialog)
const dialogActive = computed(() => isPracticeLesson.value && ['asking', 'generating', 'running', 'failed'].includes(dialogState.value?.status || ''))
const dialogStalled = computed(() => ['generating', 'running'].includes(dialogState.value?.status || '') && !inProgress.value && !dialogBusy.value)
async function sendPracticeDialog(action: string, content?: string, userExamId?: number) {
  if (dialogBusy.value || (practiceBusy.value && action !== 'cancel') || (inProgress.value && !['retry', 'cancel'].includes(action))) return
  if (action === 'answer' && !content?.trim()) return
  const lesson = Number(props.targetableId), tid = currentThreadId()
  if (!tid) { connectionNotice.value = '会話の準備中です。少し待ってからお試しください。'; return }
  closeLearningMenu()
  dialogBusy.value = true
  connectionNotice.value = ''
  try {
    const result = await practiceApi.dialog(lesson, { threadId: tid, agentId: selectedAgentId.value, dialogAction: action, courseId: props.courseId,
      settingsFingerprint: action === 'start' ? practiceSettings.value?.fingerprints.check : undefined,
      content, replyToId: latestDialogMessage.value?.id, userExamId, activeView: props.activeView })
    if (lesson !== Number(props.targetableId) || tid !== currentThreadId()) return
    if (action !== 'cancel' && action !== 'retry') {
      pendingTurnMessageId = result.messageId
      turnSpacerActive.value = true
    }
    if (action === 'answer') chatContent.value = ''
    if (action === 'cancel' && latestDialogMessage.value) {
      delete liveAgentActivities.value[latestDialogMessage.value.id]
      delete streamingContent.value[latestDialogMessage.value.id]
    }
    await refresh()
    const pendingDialog = latestDialogMessage.value
    if (pendingDialog && ['generating', 'running'].includes(pendingDialog.learningDialog?.status || '')) {
      showInitialPreparing(pendingDialog.id)
    }
  } catch (e: any) {
    if (e?.baseResponse?.data?.data?.settings) await loadPracticeSettings()
    if (lesson === Number(props.targetableId) && tid === currentThreadId()) connectionNotice.value = apiErrorMessage(e, '会話を開始できませんでした。状態を読み直してください。')
  } finally { dialogBusy.value = false }
}
watch(() => props.practiceDiscussion, value => {
  if (!value || !props.practiceEnabled) return
  if (inProgress.value || dialogBusy.value || practiceBusy.value) {
    connectionNotice.value = '現在の返信が終わってから、結果の確認ボタンを押してください。'
    return
  }
  sendPracticeDialog('review', undefined, value.attemptId)
})
watch(() => currentThreadId(), () => { if (props.practiceEnabled) resumePractice() }, { immediate: true })


const unescapeMessageContent = (content: any) => {
  if (!content) return content
  if (content.includes('&lt;div class=') && content.includes('leadform')) {
    const unescaped = content.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&').replace(/<q>/g, '"').replace(/<\/q>/g, '"')
    nextTick(() => checkFormSubmissionStatus())
    return unescaped
  }
  return content
}

const labelCodeBlocks = () => {
  document.querySelectorAll('.message-content-wrapper .highlight-container').forEach((container) => {
    const label = container.querySelector('.highlight-lang')
    const code = container.querySelector('pre.highlight')
    if (!label || !code || label.textContent) return

    const language = Array.from(code.classList).find(className => className !== 'highlight')
    if (language) label.textContent = language
  })
}

const disableFormFields = (form: any) => { form.querySelectorAll('input, textarea, select, button').forEach((f: any) => { f.disabled = true; if (f.tagName !== 'BUTTON') { f.style.backgroundColor = '#f8f9fa'; f.style.color = '#6c757d'; f.style.cursor = 'not-allowed'; f.style.opacity = '0.7' } }) }
const showLeadformMessage = (container: any, type: string, message: string) => {
  container.querySelectorAll('button').forEach((b: any) => b.style.display = 'none')
  container.querySelectorAll('.leadform-message').forEach((m: any) => m.remove())
  const el = document.createElement('div'); el.className = 'leadform-message'; container.appendChild(el)
  const styles: any = { success: { bg: '#d4edda', border: '#c3e6cb', color: '#155724' }, error: { bg: '#f8d7da', border: '#f5c6cb', color: '#721c24' }, dismiss: { bg: '#e3f2fd', border: '#bbdefb', color: '#1565c0' } }
  const s = styles[type] || styles.dismiss
  el.innerHTML = `<div style="display:flex;align-items:center;gap:8px;background:${s.bg};padding:16px 20px;border-radius:8px;border:1px solid ${s.border};font-size:14px;justify-content:center;"><span style="color:${s.color};font-weight:500;">${message}</span></div>`
}

const checkFormSubmissionStatus = async () => {
  const forms = Array.from(document.querySelectorAll('.leadform-form'))
  for (const form of forms) {
    const formId = (form as HTMLElement).getAttribute('data-form-id'); if (!formId) continue
    const mc = (form as HTMLElement).closest('.message-content-wrapper'); const messageId = mc ? mc.id.replace('message-content-', '') : null; if (!messageId) continue
    try {
      const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      const res = await fetch(`/api/v2/lead_submissions/check_status?form_id=${formId}&message_id=${messageId}`, { method: 'GET', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf || '' } })
      const result = await res.json()
      if (result.submitted) { const container = (form as HTMLElement).closest('.leadform-container') || (form as HTMLElement).closest('[class*="leadform"]'); disableFormFields(form); showLeadformMessage(container, 'success', result.success_message || 'フォームは既に送信済みです。') }
    } catch {}
  }
}

const handleLeadformButtons = (e: any) => { if (e.target.matches('.leadform-dismiss-btn, .leadform-form .btn-dismiss, .leadform-form .btn-secondary')) { e.preventDefault(); handleLeadformDismiss(e) } }
const handleLeadformSubmit = async (e: any) => {
  const form = e.target; const container = form.closest('.leadform-container') || form.closest('[class*="leadform"]')
  if (!form.matches('.leadform-form') && !form.querySelector('.leadform-form')) return
  if (form.dataset.submitting === 'true') { e.preventDefault(); return }
  const submitBtn = form.querySelector('button[type="submit"], .btn-submit, .btn-primary')
  if (!form.checkValidity()) return
  e.preventDefault(); form.dataset.submitting = 'true'; const originalText = submitBtn?.textContent
  try {
    const formData = new FormData(form); const formDataObj: any = {}; const formId = form.getAttribute('data-form-id'); if (!formId) return
    const checkboxGroups: any = {}
    formData.forEach((v, k) => { if (k !== 'form_id') { if (k.endsWith('[]')) { const fn = k.replace('[]', ''); if (!checkboxGroups[fn]) checkboxGroups[fn] = []; checkboxGroups[fn].push(v) } else { formDataObj[k] = v } } })
    Object.keys(checkboxGroups).forEach(fn => { formDataObj[fn] = checkboxGroups[fn] })
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = '送信中...' }
    const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    const mc = form.closest('.message-content-wrapper'); const messageId = mc ? mc.id.replace('message-content-', '') : null; if (!messageId) { showLeadformMessage(container, 'error', 'システムエラーが発生しました'); return }
    const res = await fetch('/api/v2/lead_submissions', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf || '' }, body: JSON.stringify({ form_id: formId, form_data: formDataObj, chat_context: { timestamp: new Date().toISOString(), dashboard_classroom: true, message_id: messageId } }) })
    let result; try { result = await res.json() } catch { result = { success: false, error: 'Invalid JSON response' } }
    if (result?.success) { disableFormFields(form); showLeadformMessage(container, 'success', result.message || container.getAttribute('data-success-message')) } else { form.dataset.submitting = 'false'; if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText }; showLeadformMessage(container, 'error', result?.error || container.getAttribute('data-error-message') || 'エラーが発生しました') }
  } catch { form.dataset.submitting = 'false'; if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText || '送信' }; showLeadformMessage(container, 'error', container.getAttribute('data-error-message') || 'ネットワークエラーが発生しました') }
}

const handleLeadformDismiss = async (e: any) => {
  const btn = e.target; const container = btn.closest('.leadform-container') || btn.closest('[class*="leadform"]'); const form = container?.querySelector('.leadform-form') || container?.querySelector('form'); if (!form) return
  const mc = form.closest('.message-content-wrapper'); const messageId = mc ? mc.id.replace('message-content-', '') : null; const formId = form.getAttribute('data-form-id')
  if (!messageId || !formId) { disableFormFields(form); showLeadformMessage(container, 'dismiss', container.getAttribute('data-dismiss-message')); return }
  try {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    await fetch('/api/v2/lead_submissions/dismiss', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf || '' }, body: JSON.stringify({ form_id: formId, chat_context: { timestamp: new Date().toISOString(), dashboard_classroom: true, message_id: messageId, action: 'dismiss' } }) })
  } catch {}
  disableFormFields(form); showLeadformMessage(container, 'dismiss', container.getAttribute('data-dismiss-message'))
}

const setupBannerObserver = () => { /* ... banner observer logic ... */ }
const setupBannerImageListeners = () => { /* ... */ }
const handleImageLoad = () => setTimeout(() => autoExpandTextarea(), 50)
const setupLeadformHandlers = () => { document.removeEventListener('click', handleLeadformButtons); document.removeEventListener('submit', handleLeadformSubmit); document.addEventListener('click', handleLeadformButtons); document.addEventListener('submit', handleLeadformSubmit) }

// Watchers
watch(selectedAgentId, async () => { try { if (selectedAgentId.value) { const agent = await api.aiTutorAgent.show(selectedAgentId.value, { targetableId: targetableIdStr.value, targetableType: props.targetableType }); if ((agent as any).welcomeMessage) welcomeMessage.value = (agent as any).welcomeMessage } } catch {} })
watch(messages, () => {
  const thread = currentThreadId()
  const anchor = visibleAnchor || captureVisibleAnchor()
  nextTick(() => {
    if (pendingTurnMessageId && messages.value.some(message => message.id === pendingTurnMessageId)) {
      scrollToMessageStart(pendingTurnMessageId)
      pendingTurnMessageId = null
    } else if (!initialScrollDone.value || lastRenderedThread !== thread) {
      const saved = threadAnchors.get(thread)
      if (saved) restoreVisibleAnchor(saved)
      else showLatestAnswer()
      initialScrollDone.value = true
    } else if (autoFollow.value) scrollToLast()
    else restoreVisibleAnchor(anchor)
    lastRenderedThread = thread
    visibleAnchor = captureVisibleAnchor()
    requestAnimationFrame(updateScrollHints)
  })
})
watch(streamingContent, () => nextTick(() => { if (autoFollow.value) scrollToLast(); else restoreVisibleAnchor(visibleAnchor); requestAnimationFrame(updateScrollHints) }), { deep: true })
watch(() => route.fullPath, () => { closeLearningMenu(); changeRoute() })

// Lifecycle
onMounted(async () => {
  document.addEventListener('pointerdown', closeLearningMenuOutside)
  try {
    const tid = threadIdQuery.value || ''
    const result = await api.message.index({ targetableId: targetableIdStr.value, targetableType: props.targetableType, threadId: tid, courseId: props.courseId })
    messages.value = result[1]
    const meta = result[0] || {}
    // URLの会話IDが無い、または別のレッスンのものなら、サーバーが選んだこのレッスンの会話に合わせる
    if (meta.threadId && String(meta.threadId) !== String(threadIdQuery.value || '')) { threadId.value = String(meta.threadId); router.replace({ query: { ...route.query, thread_id: String(meta.threadId) } }).catch(e => { if (e.name != 'NavigationDuplicated') throw e }) }
    lastDraftKey = `${props.targetableType}:${props.targetableId}:${currentThreadId()}`
    if (props.toggleCreateThreadBtn) props.toggleCreateThreadBtn(!!messages.value.length)
    messageCount.value = meta.totalMessage; limitMessage.value = meta.limitMessage; showCountLimitMessage.value = meta.showCountLimitMessage
    try { availableAgents.value = await api.aiTutorAgent.index({ targetableId: targetableIdStr.value, targetableType: props.targetableType }); let defaultAgent = props.targetableType === 'Lesson' ? availableAgents.value.find(a => a.is_course_default) : null; if (!defaultAgent && availableAgents.value.length > 0) defaultAgent = availableAgents.value[0]; selectedAgentId.value = defaultAgent?.id || null; choosePracticeDefaultAgent(); const selected = availableAgents.value.find(a => a.id === selectedAgentId.value); if (selected?.welcomeMessage) welcomeMessage.value = selected.welcomeMessage } catch {}
    inProgress.value = latestBotIsPending()
    if (inProgress.value) startGenerationRecovery()
    createChannel()
  } catch {}
  
  if (chatContainer.value) {
    chatScrollHandler.value = () => {
      updateScrollHints()
      if (programmaticScroll) return
      autoFollow.value = false
      visibleAnchor = captureVisibleAnchor()
      if (visibleAnchor) threadAnchors.set(currentThreadId(), visibleAnchor)
    }
    chatContainer.value.addEventListener('scroll', chatScrollHandler.value, { passive: true })
  }
  document.getElementById('chat-input')?.addEventListener('input', autoExpandTextarea)
  if (chatInput.value) chatInput.value.addEventListener('paste', (e: any) => { e.preventDefault(); if (e.clipboardData.files.length) { if (file.value) file.value.files = e.clipboardData.files; handleFileChange() } else { navigator.clipboard.readText().then(t => chatContent.value += t) } })
  document.addEventListener("click", handleCopy); document.addEventListener("click", handleZoomHighlight); document.addEventListener("click", handleZoomImage)
  aiChatQuestions.value = await api.aiChatQuestionApi.index({ context: chatQuestionContext(), targetableId: targetableIdStr.value, targetableType: props.targetableType })
  try { resizeObserver.value = new ResizeObserver(() => { if (resizeThrottleTimer.value) clearTimeout(resizeThrottleTimer.value); resizeThrottleTimer.value = setTimeout(() => { if (autoFollow.value) scrollToLastImm(); else restoreVisibleAnchor(visibleAnchor); updateScrollHints() }, 50) }); if (chatContainer.value) resizeObserver.value.observe(chatContainer.value) } catch {}
  containerLoadHandler.value = () => { if (autoFollow.value) scrollToLastImm(); else restoreVisibleAnchor(visibleAnchor) }; chatContainer.value?.addEventListener('load', containerLoadHandler.value, true)
  // ダッシュボード：非表示のあいだ（スマホのモーダルを開く前）は高さを測れない。入力欄まわりが表示された・大きさが変わったときに測り直す
  // （これが無いと、モーダルを開いてから最初に入力するまで、入力欄の下に余白が残る）
  if (props.isDashboard) try { const area = chatContainer.value?.parentElement?.querySelector('.chat-composer-area'); if (area) { composerObserver = new ResizeObserver(() => autoExpandTextarea()); composerObserver.observe(area) } } catch {}
  // スマホのモーダルは下からスライドして開く。動いている途中で測ると位置がずれるので、開き終わったときにも測り直す
  if (props.isDashboard) { dashboardModal = chatContainer.value?.closest<HTMLElement>('.modal') || null; dashboardModal?.addEventListener('transitionend', remeasureDashboardHeight); dashboardModal?.addEventListener('shown.bs.modal', remeasureDashboardHeight) }
  setupLeadformHandlers()
})

onUpdated(() => {
  document.getElementById('chat-input')?.dispatchEvent(new Event("input"))
  labelCodeBlocks()
})

onBeforeUnmount(() => {
  composerObserver?.disconnect(); composerObserver = null
  dashboardModal?.removeEventListener('transitionend', remeasureDashboardHeight); dashboardModal?.removeEventListener('shown.bs.modal', remeasureDashboardHeight); dashboardModal = null
  document.removeEventListener('pointerdown', closeLearningMenuOutside)
  document.removeEventListener("click", handleCopy); document.removeEventListener("click", handleZoomHighlight); document.removeEventListener("click", handleZoomImage); document.removeEventListener("click", handleLeadformButtons); document.removeEventListener("submit", handleLeadformSubmit)
  if (chatContainer.value && containerLoadHandler.value) chatContainer.value.removeEventListener('load', containerLoadHandler.value, true)
  if (chatContainer.value && chatScrollHandler.value) chatContainer.value.removeEventListener('scroll', chatScrollHandler.value)
  if (chanel.value) { chanel.value.unsubscribe(); chanel.value = null }
  stopGenerationRecovery()
  if (scrollAnimationFrame.value !== null) cancelAnimationFrame(scrollAnimationFrame.value)
  if (resizeObserver.value) { try { resizeObserver.value.disconnect() } catch {}; resizeObserver.value = null }
  if (bannerObserver.value) { try { bannerObserver.value.disconnect() } catch {}; bannerObserver.value = null }
})

// Expose for parent components
__expose({ createThread, scrollToLast, refresh })

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!

  return (__props.showComponent)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        flat: "",
        class: "bg-white d-flex flex-column justify-content-between position-relative message-container-wrapper",
        onDragover: _cache[28] || (_cache[28] = ($event: any) => (modelSupportsVision.value ? dragover($event) : undefined)),
        onDragleave: _cache[29] || (_cache[29] = ($event: any) => (modelSupportsVision.value ? dragleave() : undefined)),
        onDrop: _cache[30] || (_cache[30] = ($event: any) => (modelSupportsVision.value ? drop($event) : undefined))
      }, [
        (messageCount.value >= limitMessage.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "chat-container flex-grow-1 d-flex flex-column justify-content-between text-center",
              id: "chat-container",
              ref_key: "chatContainer",
              ref: chatContainer
            }, [
              _createElementVNode("div", _hoisted_1, [
                _cache[32] || (_cache[32] = _createElementVNode("p", null, "チャットは回数オーバーです。", -1 /* CACHED */)),
                _cache[33] || (_cache[33] = _createElementVNode("p", null, "有料プランをご検討ください", -1 /* CACHED */)),
                (showCountLimitMessage.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, [...(_cache[31] || (_cache[31] = [
                      _createElementVNode("a", {
                        href: "/premium_services",
                        target: "_blank"
                      }, "プランを変更する", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true)
              ])
            ], 512 /* NEED_PATCH */))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "chat-container flex-grow-1 d-flex flex-column",
              id: "chat-container",
              ref_key: "chatContainer",
              ref: chatContainer
            }, [
              _createElementVNode("audio", {
                ref_key: "speechMedia",
                ref: speechMedia,
                style: {"display":"none"}
              }, null, 512 /* NEED_PATCH */),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("img", {
                        src: (selectedAgent.value && selectedAgent.value.imageUrl) ? selectedAgent.value.imageUrl : _unref(logoBot),
                        alt: "chatbot-img"
                      }, null, 8 /* PROPS */, _hoisted_6),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(welcomeMessage.value), 1 /* TEXT */)
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message, messageIndex) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `msg-${message.id}`
                  }, [
                    _createCommentVNode(" Bot message "),
                    (message.isBot)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "chat incoming",
                          "data-message-id": message.id
                        }, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("img", {
                                src: getAgentAvatar(message),
                                alt: "chatbot-img"
                              }, null, 8 /* PROPS */, _hoisted_11),
                              _createElementVNode("div", _hoisted_12, [
                                (agentActivitiesFor(message).length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      _createElementVNode("div", _hoisted_14, [
                                        _cache[34] || (_cache[34] = _createElementVNode("span", null, "エージェントの実行状況", -1 /* CACHED */)),
                                        _createElementVNode("span", null, _toDisplayString(completedActivityCount(message)) + "/" + _toDisplayString(agentActivitiesFor(message).length), 1 /* TEXT */)
                                      ]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agentActivitiesFor(message), (activity, activityIndex) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: `${message.id}-activity-${activityIndex}`,
                                          class: _normalizeClass(["agent-activity-row", activityState(activity)])
                                        }, [
                                          _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("span", _hoisted_16, [
                                              (activityState(activity) === 'done')
                                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                                    key: 0,
                                                    size: "14"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                                      _createTextVNode("mdi-check", -1 /* CACHED */)
                                                    ]))]),
                                                    _: 1 /* STABLE */
                                                  }))
                                                : (activityState(activity) === 'error')
                                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                                      key: 1,
                                                      size: "14"
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                                        _createTextVNode("mdi-alert", -1 /* CACHED */)
                                                      ]))]),
                                                      _: 1 /* STABLE */
                                                    }))
                                                  : _createCommentVNode("v-if", true)
                                            ]),
                                            (activityIndex + 1 < agentActivitiesFor(message).length)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                                              : _createCommentVNode("v-if", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("div", _hoisted_19, _toDisplayString(activityDisplayMessage(activity)), 1 /* TEXT */),
                                            (activityMeta(activity))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(activityMeta(activity)), 1 /* TEXT */))
                                              : _createCommentVNode("v-if", true)
                                          ])
                                        ], 2 /* CLASS */))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                (hasReasoningContent(message))
                                  ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                                      key: 1,
                                      accordion: "",
                                      class: "admin-reasoning-panel mb-2",
                                      id: `message-reasoning-container-${message.id}`
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_expansion_panel, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_expansion_panel_title, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_21, [
                                                  _createVNode(_component_v_icon, { size: "17" }, {
                                                    default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                                      _createTextVNode("mdi-brain", -1 /* CACHED */)
                                                    ]))]),
                                                    _: 1 /* STABLE */
                                                  }),
                                                  _cache[38] || (_cache[38] = _createElementVNode("span", null, "思考過程（管理者のみ）", -1 /* CACHED */)),
                                                  (streamingReasoningContent.value[message.id] && !getDisplayContent(message))
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "●"))
                                                    : _createCommentVNode("v-if", true)
                                                ])
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */),
                                            _createVNode(_component_v_expansion_panel_text, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_23, _toDisplayString(message.reasoningContent || streamingReasoningContent.value[message.id] || ''), 1 /* TEXT */)
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id"]))
                                  : _createCommentVNode("v-if", true),
                                (!getDisplayContent(message) && ['stalled', 'stopped'].includes(message.generationState || ''))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                      _cache[39] || (_cache[39] = _createTextVNode(" 回答を復元できませんでした。", -1 /* CACHED */)),
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: refreshLearningState
                                      }, "状態を読み直す")
                                    ]))
                                  : (!getDisplayContent(message))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[40] || (_cache[40] = [
                                        _createElementVNode("div", { class: "typing-dot dot1" }, null, -1 /* CACHED */),
                                        _createElementVNode("div", { class: "typing-dot dot2" }, null, -1 /* CACHED */),
                                        _createElementVNode("div", { class: "typing-dot dot3" }, null, -1 /* CACHED */)
                                      ]))]))
                                    : _createCommentVNode("v-if", true),
                                (practicePartialContent.value[message.id] !== undefined)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 4,
                                      class: "message-content-wrapper practice-partial",
                                      id: `message-content-${message.id}`
                                    }, _toDisplayString(practicePartialContent.value[message.id]), 9 /* TEXT, PROPS */, _hoisted_26))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 5,
                                      class: "message-content-wrapper",
                                      id: `message-content-${message.id}`,
                                      innerHTML: unescapeMessageContent(getDisplayContent(message))
                                    }, null, 8 /* PROPS */, _hoisted_27)),
                                (isPracticeLesson.value && message.id === latestDialogMessage.value?.id && messageIndex === messages.value.length - 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                      (practiceSettings.value && dialogState.value?.status === 'complete')
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            disabled: learningActionDisabled.value,
                                            onClick: _cache[0] || (_cache[0] = ($event: any) => (startPractice('focused')))
                                          }, "確認した内容から出題（" + _toDisplayString(dialogState.value?.focusedQuestionCount ?? 3) + "問）", 9 /* TEXT, PROPS */, _hoisted_29))
                                        : _createCommentVNode("v-if", true),
                                      (dialogState.value?.status === 'failed' || dialogStalled.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            type: "button",
                                            disabled: dialogBusy.value || _unref(practiceBusy),
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (sendPracticeDialog('retry')))
                                          }, "確認を再試行する", 8 /* PROPS */, _hoisted_30))
                                        : _createCommentVNode("v-if", true),
                                      (dialogState.value?.status === 'cancelled')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, "確認を終了しました。自由に質問できます。"))
                                        : _createCommentVNode("v-if", true)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                (message.attachments && message.attachments.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.attachments, (attachment, index) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                          key: `att-${message.id}-${index}`
                                        }, [
                                          (['PNG', 'JPG', 'JPEG'].includes(getFileExtFromString(attachment.filename)))
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: attachment.url,
                                                alt: "image",
                                                class: "message-attachment-image",
                                                loading: "lazy",
                                                style: {"aspect-ratio":"auto","max-width":"100%","height":"auto"}
                                              }, null, 8 /* PROPS */, _hoisted_33))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                _createElementVNode("div", {
                                                  class: "chat-input-attachment d-flex",
                                                  onClick: ($event: any) => (openUrl(attachment.url))
                                                }, [
                                                  _createElementVNode("div", _hoisted_36, [
                                                    _createVNode(FileIcon, {
                                                      fileName: attachment.filename
                                                    }, null, 8 /* PROPS */, ["fileName"])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_37, [
                                                    _createElementVNode("div", _hoisted_38, _toDisplayString(getFileNameFromString(attachment.filename)), 1 /* TEXT */),
                                                    _createElementVNode("div", _hoisted_39, _toDisplayString(getFileExtFromString(attachment.filename)), 1 /* TEXT */)
                                                  ])
                                                ], 8 /* PROPS */, _hoisted_35)
                                              ]))
                                        ], 64 /* STABLE_FRAGMENT */))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                (sourceCount(message) > 0)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 8,
                                      type: "button",
                                      class: "message-sources-summary",
                                      onClick: ($event: any) => (openSources(message))
                                    }, [
                                      _createElementVNode("span", _hoisted_41, [
                                        _createVNode(_component_v_icon, { size: "18" }, {
                                          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                            _createTextVNode("mdi-file-document-multiple-outline", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        })
                                      ]),
                                      _cache[43] || (_cache[43] = _createElementVNode("span", { class: "message-sources-copy" }, [
                                        _createElementVNode("strong", null, "参照したソース"),
                                        _createElementVNode("small", null, "回答に使用した資料を確認")
                                      ], -1 /* CACHED */)),
                                      _createElementVNode("span", _hoisted_42, _toDisplayString(sourceCount(message)) + "件", 1 /* TEXT */),
                                      _createVNode(_component_v_icon, { size: "18" }, {
                                        default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                          _createTextVNode("mdi-chevron-right", -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      })
                                    ], 8 /* PROPS */, _hoisted_40))
                                  : _createCommentVNode("v-if", true),
                                _withDirectives(_createElementVNode("div", {
                                  id: `message-${message.id}-actions`,
                                  class: "message-actions"
                                }, [
                                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                    activator: _withCtx(({ props }) => [
                                      _withDirectives(_createVNode(_component_v_btn, _mergeProps({
                                        plain: "",
                                        icon: true,
                                        onClick: ($event: any) => (speech(messageIndex)),
                                        size: "small"
                                      }, { ref_for: true }, props), {
                                        default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                          _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 24 24",
                                            fill: "currentColor"
                                          }, [
                                            _createElementVNode("path", { d: "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" })
                                          ], -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }, 16 /* FULL_PROPS */, ["onClick"]), [
                                        [_vShow, !message.speechPlaying]
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[45] || (_cache[45] = _createElementVNode("span", null, "Read Aloud", -1 /* CACHED */))
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */),
                                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                    activator: _withCtx(({ props }) => [
                                      _withDirectives(_createVNode(_component_v_btn, _mergeProps({
                                        plain: "",
                                        icon: true,
                                        onClick: stopStream,
                                        size: "small"
                                      }, { ref_for: true }, props, { style: {"color":"#343541"} }), {
                                        default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                                          _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 24 24",
                                            fill: "currentColor"
                                          }, [
                                            _createElementVNode("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 14H8V8h8v8z" })
                                          ], -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }, 16 /* FULL_PROPS */), [
                                        [_vShow, message.speechPlaying]
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[47] || (_cache[47] = _createElementVNode("span", null, "Stop", -1 /* CACHED */))
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */),
                                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_btn, _mergeProps({
                                        plain: "",
                                        icon: true,
                                        onClick: ($event: any) => (copyMessage(messageIndex)),
                                        size: "small"
                                      }, { ref_for: true }, props), {
                                        default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                          _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 24 24",
                                            fill: "currentColor"
                                          }, [
                                            _createElementVNode("path", { d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" })
                                          ], -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }, 16 /* FULL_PROPS */, ["onClick"])
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[49] || (_cache[49] = _createElementVNode("span", null, "Copy", -1 /* CACHED */))
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */),
                                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                    activator: _withCtx(({ props }) => [
                                      _withDirectives(_createVNode(_component_v_btn, _mergeProps({
                                        plain: "",
                                        icon: true,
                                        onClick: ($event: any) => (regenerate(messageIndex)),
                                        size: "small"
                                      }, { ref_for: true }, props), {
                                        default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                          _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 24 24",
                                            fill: "currentColor"
                                          }, [
                                            _createElementVNode("path", { d: "M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z" })
                                          ], -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }, 16 /* FULL_PROPS */, ["onClick"]), [
                                        [_vShow, messageIndex + 1 === messages.value.length]
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[51] || (_cache[51] = _createElementVNode("span", null, "Regenerate", -1 /* CACHED */))
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ], 8 /* PROPS */, _hoisted_43), [
                                  [_vShow, message.contentRaw]
                                ])
                              ])
                            ])
                          ])
                        ], 8 /* PROPS */, _hoisted_8))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createCommentVNode(" User message "),
                          _createElementVNode("div", {
                            class: "chat outgoing",
                            "data-message-id": message.id
                          }, [
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("img", {
                                  src: message.userAvatar,
                                  alt: "user-img"
                                }, null, 8 /* PROPS */, _hoisted_47),
                                _createElementVNode("div", {
                                  class: _normalizeClass(`message-content message-content-${message.id}`)
                                }, [
                                  _createTextVNode(_toDisplayString(message.content) + " ", 1 /* TEXT */),
                                  (message.attachments && message.attachments.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.attachments, (attachment, index) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, {
                                            key: `att-${message.id}-${index}`
                                          }, [
                                            (['PNG', 'JPG', 'JPEG'].includes(getFileExtFromString(attachment.filename)))
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: attachment.url,
                                                  alt: "image",
                                                  class: "message-attachment-image",
                                                  loading: "lazy",
                                                  style: {"aspect-ratio":"auto","max-width":"100%","height":"auto"}
                                                }, null, 8 /* PROPS */, _hoisted_49))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                  _createElementVNode("div", {
                                                    class: "chat-input-attachment d-flex",
                                                    onClick: ($event: any) => (openUrl(attachment.url))
                                                  }, [
                                                    _createElementVNode("div", _hoisted_52, [
                                                      _createVNode(FileIcon, {
                                                        fileName: attachment.filename
                                                      }, null, 8 /* PROPS */, ["fileName"])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_53, [
                                                      _createElementVNode("div", _hoisted_54, _toDisplayString(getFileNameFromString(attachment.filename)), 1 /* TEXT */),
                                                      _createElementVNode("div", _hoisted_55, _toDisplayString(getFileExtFromString(attachment.filename)), 1 /* TEXT */)
                                                    ])
                                                  ], 8 /* PROPS */, _hoisted_51)
                                                ]))
                                          ], 64 /* STABLE_FRAGMENT */))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ], 2 /* CLASS */)
                              ])
                            ])
                          ], 8 /* PROPS */, _hoisted_44)
                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  ], 64 /* STABLE_FRAGMENT */))
                }), 128 /* KEYED_FRAGMENT */)),
                (isPracticeLesson.value && shouldShowSuggestionQuestions.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _cache[54] || (_cache[54] = _createElementVNode("p", null, "質問を入力するか、ここから始められます", -1 /* CACHED */)),
                      (practiceSettings.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            disabled: learningActionDisabled.value,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (sendPracticeDialog('start')))
                          }, [
                            _cache[52] || (_cache[52] = _createTextVNode("理解度を確認する ", -1 /* CACHED */)),
                            _createElementVNode("span", null, _toDisplayString(checkHint.value), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_57))
                        : _createCommentVNode("v-if", true),
                      (showComprehensiveButton.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            disabled: learningActionDisabled.value,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (startPractice('comprehensive')))
                          }, [
                            _cache[53] || (_cache[53] = _createTextVNode("レッスンから出題 ", -1 /* CACHED */)),
                            _createElementVNode("span", null, "このレッスンから" + _toDisplayString(comprehensiveCount.value) + "問", 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_58))
                        : _createCommentVNode("v-if", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lessonSuggestions.value, (question) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: question.id,
                          type: "button",
                          disabled: chatActionDisabled.value,
                          onClick: ($event: any) => (sendSuggestQuestion(question))
                        }, _toDisplayString(question.title), 9 /* TEXT, PROPS */, _hoisted_59))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Show suggestion questions after messages if conditions are met "),
                (shouldShowSuggestionQuestions.value && !isPracticeLesson.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      (aiChatQuestions.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            (aiChatQuestions.value[0])
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "suggestion-question",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (sendSuggestQuestion(aiChatQuestions.value[0])))
                                }, [
                                  _createElementVNode("div", _hoisted_62, [
                                    (aiChatQuestions.value[0].icon)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: aiChatQuestions.value[0].icon
                                        }, null, 8 /* PROPS */, _hoisted_63))
                                      : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                                          default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                            _createTextVNode("mdi-message-draw", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }))
                                  ]),
                                  _createElementVNode("div", _hoisted_64, _toDisplayString(aiChatQuestions.value[0].title), 1 /* TEXT */)
                                ]))
                              : _createCommentVNode("v-if", true),
                            (aiChatQuestions.value[1])
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "suggestion-question",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (sendSuggestQuestion(aiChatQuestions.value[1])))
                                }, [
                                  _createElementVNode("div", _hoisted_65, [
                                    (aiChatQuestions.value[1].icon)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: aiChatQuestions.value[1].icon
                                        }, null, 8 /* PROPS */, _hoisted_66))
                                      : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                                          default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                            _createTextVNode("mdi-message-draw", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }))
                                  ]),
                                  _createElementVNode("div", _hoisted_67, _toDisplayString(aiChatQuestions.value[1].title), 1 /* TEXT */)
                                ]))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true),
                      (aiChatQuestions.value.length > 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            (aiChatQuestions.value[2])
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "suggestion-question",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (sendSuggestQuestion(aiChatQuestions.value[2])))
                                }, [
                                  _createElementVNode("div", _hoisted_69, [
                                    (aiChatQuestions.value[2].icon)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: aiChatQuestions.value[2].icon
                                        }, null, 8 /* PROPS */, _hoisted_70))
                                      : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                                          default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                            _createTextVNode("mdi-message-draw", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }))
                                  ]),
                                  _createElementVNode("div", _hoisted_71, _toDisplayString(aiChatQuestions.value[2].title), 1 /* TEXT */)
                                ]))
                              : _createCommentVNode("v-if", true),
                            (aiChatQuestions.value[3])
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "suggestion-question",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (sendSuggestQuestion(aiChatQuestions.value[3])))
                                }, [
                                  _createElementVNode("div", _hoisted_72, [
                                    (aiChatQuestions.value[3].icon)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: aiChatQuestions.value[3].icon
                                        }, null, 8 /* PROPS */, _hoisted_73))
                                      : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                                          default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                            _createTextVNode("mdi-message-draw", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }))
                                  ]),
                                  _createElementVNode("div", _hoisted_74, _toDisplayString(aiChatQuestions.value[3].title), 1 /* TEXT */)
                                ]))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", {
                id: "last-message",
                class: _normalizeClass({ 'chat-turn-spacer': turnSpacerActive.value }),
                style: {"margin-top":"10px"}
              }, null, 2 /* CLASS */)
            ], 512 /* NEED_PATCH */)),
        _createCommentVNode(" 下に読んでいない部分があるときだけ出す。最新の回答の冒頭がまだ見えていなければ冒頭へ、見えていれば一番下へ "),
        (hiddenBelow.value && messages.value.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "scroll-to-latest",
              "aria-label": latestAnswerBelow.value ? '新しい回答の冒頭へ移動' : 'いちばん下へ移動',
              onClick: scrollDownOnce
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                  _createTextVNode("mdi-arrow-down", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }),
              _createTextVNode(" " + _toDisplayString(latestAnswerBelow.value ? '新しい回答' : '下へ'), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_75))
          : _createCommentVNode("v-if", true),
        (connectionNotice.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(connectionNotice.value), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_77, [
          (isPracticeLesson.value && _unref(practiceBusy))
            ? (_openBlock(), _createElementBlock("div", _hoisted_78, "練習問題を準備しています…"))
            : _createCommentVNode("v-if", true),
          (isPracticeLesson.value && _unref(practiceWaiting))
            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                _cache[60] || (_cache[60] = _createTextVNode("問題を作成中です。時間がかかっています。", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  onClick: refreshLearningState
                }, "状態を読み直す")
              ]))
            : _createCommentVNode("v-if", true),
          (isPracticeLesson.value && _unref(practiceError))
            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                _createTextVNode(_toDisplayString(_unref(practiceError)) + " ", 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "button",
                  disabled: _unref(practiceBusy),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (startPractice(lastPracticeMode.value)))
                }, "もう一度作成", 8 /* PROPS */, _hoisted_81),
                _createElementVNode("button", {
                  type: "button",
                  onClick: refreshLearningState
                }, "状態を読み直す"),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (practiceError.value = ''))
                }, "閉じる")
              ]))
            : _createCommentVNode("v-if", true),
          (chatSendError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                _createTextVNode(_toDisplayString(chatSendError.value) + " ", 1 /* TEXT */),
                (pendingSendForm.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (createMessage()))
                    }, "再送"))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                  type: "button",
                  onClick: refreshLearningState
                }, "状態を読み直す")
              ]))
            : _createCommentVNode("v-if", true),
          (isPracticeLesson.value && practiceSettingsError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, _toDisplayString(practiceSettingsError.value), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Attachments display area - above input "),
          (activeAttachments.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachments.value, (attachment, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (!attachment.isDeleted)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                            _createElementVNode("div", _hoisted_87, [
                              _createElementVNode("div", _hoisted_88, [
                                _createVNode(FileIcon, {
                                  fileName: attachment.file.name
                                }, null, 8 /* PROPS */, ["fileName"])
                              ]),
                              _createElementVNode("div", _hoisted_89, [
                                _createElementVNode("div", _hoisted_90, _toDisplayString(getFileName(attachment)), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_91, _toDisplayString(getFileExt(attachment)), 1 /* TEXT */)
                              ])
                            ]),
                            _createElementVNode("div", {
                              class: "chat-input-progress-bar",
                              style: _normalizeStyle({
                  width: `${attachment.progressPercentage}%`,
                  display: `${attachment.isUploadCompleted ? 'none' : 'block'
                }`})
                            }, null, 4 /* STYLE */),
                            _createElementVNode("div", _hoisted_92, [
                              _withDirectives(_createVNode(_component_v_btn, {
                                outlined: "",
                                icon: true,
                                onClick: ($event: any) => (deleteAttachment(index))
                              }, {
                                default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                                  _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor"
                                  }, [
                                    _createElementVNode("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" })
                                  ], -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["onClick"]), [
                                [_vShow, messageCount.value < limitMessage.value && hasAvailableAgent.value]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createCommentVNode(" 入力欄。先生の選択・学習メニュー・参照中・回数は入力欄の下の1行にまとめる（別の段にしない） "),
        _createElementVNode("div", _hoisted_93, [
          (!hasAvailableAgent.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_94, " エージェントが設定されていません。管理者にお問い合わせください。 "))
            : (messageCount.value >= limitMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                  _cache[62] || (_cache[62] = _createTextVNode(" 回数制限オーバー、プランを変更する ", -1 /* CACHED */)),
                  (showCountLimitMessage.value)
                    ? (_openBlock(), _createElementBlock("a", _hoisted_96, "プランを変更する"))
                    : _createCommentVNode("v-if", true)
                ]))
              : (showCountLimitMessage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                    _createTextVNode(" 残り回数 " + _toDisplayString(messageCount.value) + "/" + _toDisplayString(limitMessage.value) + "、", 1 /* TEXT */),
                    _cache[63] || (_cache[63] = _createElementVNode("a", {
                      href: "/premium_services",
                      target: "_blank"
                    }, "プランを変更する", -1 /* CACHED */))
                  ]))
                : _createCommentVNode("v-if", true),
          _createElementVNode("div", {
            class: _normalizeClass(["chat-composer", { 'disabled': messageCount.value >= limitMessage.value || !hasAvailableAgent.value }])
          }, [
            _withDirectives(_createElementVNode("textarea", {
              ref_key: "chatInput",
              ref: chatInput,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((chatContent).value = $event)),
              id: "chat-input",
              placeholder: hasAvailableAgent.value ? (dialogActive.value ? 'あなたの考えを入力してください' : '内容を入力してください') : 'エージェントが設定されていません',
              rows: "1",
              onKeydown: handleEnterChatForm,
              disabled: messageCount.value >= limitMessage.value || !hasAvailableAgent.value
            }, "        ", 40 /* PROPS, NEED_HYDRATION */, _hoisted_98), [
              [_vModelText, chatContent.value]
            ]),
            _createElementVNode("div", _hoisted_99, [
              (modelSupportsVision.value)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    variant: "text",
                    icon: "",
                    size: "small",
                    "aria-label": "画像を添付",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (addAttachment())),
                    disabled: messageCount.value >= limitMessage.value || !hasAvailableAgent.value
                  }, {
                    default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "18",
                        height: "18",
                        viewBox: "0 0 24 24",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", { d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" })
                      ], -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["disabled"]))
                : _createCommentVNode("v-if", true),
              (availableAgents.value.length > 0 && messageCount.value < limitMessage.value)
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 1,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((selectedAgentId).value = $event)),
                    onChange: _cache[14] || (_cache[14] = ($event: any) => (userSelectedAgent.value = true)),
                    class: "chat-agent-select",
                    "aria-label": "答える先生を選ぶ"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableAgents.value, (agent) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: agent.id,
                        value: agent.id
                      }, _toDisplayString(agent.name), 9 /* TEXT, PROPS */, _hoisted_100))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */)), [
                    [_vModelSelect, selectedAgentId.value]
                  ])
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" コースで「レッスンから出題」を隠したときは、学習メニューも出さない（理解度の確認は最初の候補・新しいスレッドから） "),
              (isPracticeLesson.value && showComprehensiveButton.value)
                ? (_openBlock(), _createElementBlock("details", {
                    key: 2,
                    ref_key: "learningMenu",
                    ref: learningMenu,
                    class: "learning-menu",
                    onKeydown: _cache[19] || (_cache[19] = _withKeys(_withModifiers(($event: any) => (closeLearningMenu(true)), ["prevent"]), ["esc"])),
                    onFocusout: leaveLearningMenu
                  }, [
                    _cache[67] || (_cache[67] = _createElementVNode("summary", null, [
                      _createTextVNode("学習メニュー "),
                      _createElementVNode("span", { "aria-hidden": "true" }, "⌃")
                    ], -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_101, [
                      (practiceSettings.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            disabled: learningActionDisabled.value || dialogActive.value,
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (sendPracticeDialog('start')))
                          }, [
                            _cache[65] || (_cache[65] = _createTextVNode("理解度を確認する", -1 /* CACHED */)),
                            _createElementVNode("small", null, _toDisplayString(checkHint.value), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_102))
                        : _createCommentVNode("v-if", true),
                      (showComprehensiveButton.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            disabled: learningActionDisabled.value || dialogActive.value,
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (startPractice('comprehensive')))
                          }, [
                            _createTextVNode("レッスンから出題（" + _toDisplayString(comprehensiveCount.value) + "問）", 1 /* TEXT */),
                            _cache[66] || (_cache[66] = _createElementVNode("small", null, "このレッスンから出題します", -1 /* CACHED */))
                          ], 8 /* PROPS */, _hoisted_103))
                        : _createCommentVNode("v-if", true),
                      (practiceSettings.value && dialogState.value?.status === 'complete')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            disabled: learningActionDisabled.value,
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (startPractice('focused')))
                          }, "確認した内容から出題（" + _toDisplayString(dialogState.value?.focusedQuestionCount ?? 3) + "問）", 9 /* TEXT, PROPS */, _hoisted_104))
                        : _createCommentVNode("v-if", true),
                      (dialogActive.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            type: "button",
                            disabled: dialogBusy.value,
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (sendPracticeDialog('cancel')))
                          }, "確認を終了してチャットに戻る", 8 /* PROPS */, _hoisted_105))
                        : _createCommentVNode("v-if", true)
                    ])
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */))
                : _createCommentVNode("v-if", true),
              (isPracticeLesson.value && dialogActive.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_106, _toDisplayString(dialogState.value?.kind === 'review' ? '振り返り中' : '理解度を確認中'), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (isPracticeLesson.value && dialogActive.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 4,
                    type: "button",
                    class: "learning-exit",
                    disabled: dialogBusy.value,
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (sendPracticeDialog('cancel')))
                  }, "終了", 8 /* PROPS */, _hoisted_107))
                : _createCommentVNode("v-if", true),
              (__props.activeView)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 5,
                    class: "active-view-label",
                    role: "status",
                    title: `参照中：${activeViewLabel.value}`
                  }, "参照中：" + _toDisplayString(activeViewLabel.value), 9 /* TEXT, PROPS */, _hoisted_108))
                : _createCommentVNode("v-if", true),
              _cache[70] || (_cache[70] = _createElementVNode("span", { class: "chat-composer-spacer" }, null, -1 /* CACHED */)),
              (hasAvailableAgent.value && messageCount.value < limitMessage.value && !showCountLimitMessage.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 6,
                    class: "chat-count",
                    title: `１日に${limitMessage.value}回まで（今日は${messageCount.value}回）`
                  }, _toDisplayString(messageCount.value) + "/" + _toDisplayString(limitMessage.value), 9 /* TEXT, PROPS */, _hoisted_109))
                : _createCommentVNode("v-if", true),
              _withDirectives(_createVNode(_component_v_btn, {
                icon: "",
                size: "small",
                variant: "text",
                "aria-label": "生成を止める",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (stopGenerate()))
              }, {
                default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    fill: "currentColor"
                  }, [
                    _createElementVNode("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 14H8V8h8v8z" })
                  ], -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 512 /* NEED_PATCH */), [
                [_vShow, inProgress.value && !['generating', 'running'].includes(dialogState.value?.status || '')]
              ]),
              _withDirectives(_createVNode(_component_v_btn, {
                variant: "text",
                disabled: !canSubmit() || messageCount.value >= limitMessage.value || !hasAvailableAgent.value,
                icon: "",
                size: "small",
                "aria-label": "送信",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (createMessage()))
              }, {
                default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    fill: "currentColor"
                  }, [
                    _createElementVNode("path", { d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" })
                  ], -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled"]), [
                [_vShow, !inProgress.value]
              ])
            ])
          ], 2 /* CLASS */),
          _withDirectives(_createElementVNode("input", {
            ref_key: "file",
            ref: file,
            type: "file",
            multiple: "",
            class: "hidden",
            onChange: handleFileChange,
            accept: ".jpg, .jpeg, .png"
          }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
            [_vShow, false]
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_110, [...(_cache[71] || (_cache[71] = [
          _createStaticVNode("<div class=\"d-flex align-center\" data-v-6b1649a3><div class=\"d-flex flex-column justify-center align-center chat-input-drag-message\" data-v-6b1649a3><div class=\"mb-3\" data-v-6b1649a3><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 132 108\" fill=\"none\" width=\"132\" height=\"108\" data-v-6b1649a3><g clip-path=\"url(#clip0_3605_64419)\" data-v-6b1649a3><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M25.2025 29.3514C10.778 33.2165 8.51524 37.1357 11.8281 49.4995L13.4846 55.6814C16.7975 68.0453 20.7166 70.308 35.1411 66.443L43.3837 64.2344C57.8082 60.3694 60.0709 56.4502 56.758 44.0864L55.1016 37.9044C51.7887 25.5406 47.8695 23.2778 33.445 27.1428L29.3237 28.2471L25.2025 29.3514ZM18.1944 42.7244C18.8572 41.5764 20.325 41.1831 21.4729 41.8459L27.3517 45.24C28.4996 45.9027 28.8929 47.3706 28.2301 48.5185L24.836 54.3972C24.1733 55.5451 22.7054 55.9384 21.5575 55.2757C20.4096 54.613 20.0163 53.1451 20.6791 51.9972L22.8732 48.1969L19.0729 46.0028C17.925 45.3401 17.5317 43.8723 18.1944 42.7244ZM29.4091 56.3843C29.066 55.104 29.8258 53.7879 31.1062 53.4449L40.3791 50.9602C41.6594 50.6172 42.9754 51.377 43.3184 52.6573C43.6615 53.9376 42.9017 55.2536 41.6214 55.5967L32.3485 58.0813C31.0682 58.4244 29.7522 57.6646 29.4091 56.3843Z\" fill=\"#AFC1FF\" data-v-6b1649a3></path></g><g clip-path=\"url(#clip1_3605_64419)\" data-v-6b1649a3><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M86.8124 13.4036C81.0973 11.8722 78.5673 13.2649 77.0144 19.0603L68.7322 49.97C67.1793 55.7656 68.5935 58.2151 74.4696 59.7895L97.4908 65.958C103.367 67.5326 105.816 66.1184 107.406 60.1848L115.393 30.379C115.536 29.8456 115.217 29.2959 114.681 29.16C113.478 28.8544 112.435 28.6195 111.542 28.4183C106.243 27.2253 106.22 27.2201 109.449 20.7159C109.73 20.1507 109.426 19.4638 108.816 19.3004L86.8124 13.4036ZM87.2582 28.4311C86.234 28.1567 85.1812 28.7645 84.9067 29.7888C84.6323 30.813 85.2401 31.8658 86.2644 32.1403L101.101 36.1158C102.125 36.3902 103.178 35.7824 103.453 34.7581C103.727 33.7339 103.119 32.681 102.095 32.4066L87.2582 28.4311ZM82.9189 37.2074C83.1934 36.1831 84.2462 35.5753 85.2704 35.8497L100.107 39.8252C101.131 40.0996 101.739 41.1524 101.465 42.1767C101.19 43.201 100.137 43.8088 99.1132 43.5343L84.2766 39.5589C83.2523 39.2844 82.6445 38.2316 82.9189 37.2074ZM83.2826 43.2683C82.2584 42.9939 81.2056 43.6017 80.9311 44.626C80.6567 45.6502 81.2645 46.703 82.2888 46.9775L89.7071 48.9652C90.7313 49.2396 91.7841 48.6318 92.0586 47.6076C92.333 46.5833 91.7252 45.5305 90.7009 45.256L83.2826 43.2683Z\" fill=\"#7989FF\" data-v-6b1649a3></path></g><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M40.4004 71.8426C40.4004 57.2141 44.0575 53.5569 61.1242 53.5569H66.0004H70.8766C87.9432 53.5569 91.6004 57.2141 91.6004 71.8426V79.1569C91.6004 93.7855 87.9432 97.4426 70.8766 97.4426H61.1242C44.0575 97.4426 40.4004 93.7855 40.4004 79.1569V71.8426ZM78.8002 67.4995C78.8002 70.1504 76.6512 72.2995 74.0002 72.2995C71.3492 72.2995 69.2002 70.1504 69.2002 67.4995C69.2002 64.8485 71.3492 62.6995 74.0002 62.6995C76.6512 62.6995 78.8002 64.8485 78.8002 67.4995ZM60.7204 70.8597C60.2672 70.2553 59.5559 69.8997 58.8004 69.8997C58.045 69.8997 57.3337 70.2553 56.8804 70.8597L47.2804 83.6597C46.4851 84.72 46.7 86.2244 47.7604 87.0197C48.8208 87.8149 50.3251 87.6 51.1204 86.5397L58.8004 76.2997L66.4804 86.5397C66.8979 87.0962 67.5363 87.4443 68.2303 87.4936C68.9243 87.5429 69.6055 87.2887 70.0975 86.7967L74.8004 82.0938L79.5034 86.7967C80.4406 87.734 81.9602 87.734 82.8975 86.7967C83.8347 85.8595 83.8347 84.3399 82.8975 83.4026L76.4975 77.0026C75.5602 76.0653 74.0406 76.0653 73.1034 77.0026L68.6601 81.4459L60.7204 70.8597Z\" fill=\"#3C46FF\" data-v-6b1649a3></path><defs data-v-6b1649a3><clipPath id=\"clip0_3605_64419\" data-v-6b1649a3><rect width=\"56\" height=\"56\" fill=\"white\" transform=\"translate(0 26.9939) rotate(-15)\" data-v-6b1649a3></rect></clipPath><clipPath id=\"clip1_3605_64419\" data-v-6b1649a3><rect width=\"64\" height=\"64\" fill=\"white\" transform=\"translate(69.5645 0.5) rotate(15)\" data-v-6b1649a3></rect></clipPath></defs></svg></div><div data-v-6b1649a3><h3 data-v-6b1649a3>追加してみましょう</h3><h4 data-v-6b1649a3>会話に追加するファイルをここにドロップしてください</h4></div></div></div>", 1)
        ]))], 512 /* NEED_PATCH */), [
          [_vShow, isDragging.value && modelSupportsVision.value]
        ]),
        _createVNode(_component_v_dialog, {
          modelValue: codeDialog.value,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((codeDialog).value = $event)),
          "max-width": "800"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, {
                  innerHTML: dialogHTML.value,
                  class: "d-flex pt-6"
                }, null, 8 /* PROPS */, ["innerHTML"]),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (codeDialog.value = false))
                    }, {
                      default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                        _createTextVNode("近い", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          modelValue: sourceDialog.value,
          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((sourceDialog).value = $event)),
          "max-width": "720"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
                  default: _withCtx(() => [
                    _cache[74] || (_cache[74] = _createElementVNode("span", null, "参照ソース", -1 /* CACHED */)),
                    _createVNode(_component_v_btn, {
                      icon: "",
                      variant: "text",
                      size: "small",
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (sourceDialog.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                            _createTextVNode("mdi-close", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sourceSections(activeSourceMessage.value), (section) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: section.key,
                        class: "source-section"
                      }, [
                        _createElementVNode("div", _hoisted_111, [
                          _createVNode(_component_v_icon, { size: "18" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(section.icon), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */),
                          _createTextVNode(" " + _toDisplayString(section.title), 1 /* TEXT */)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.sources, (source) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: sourceKey(source),
                            class: "source-item"
                          }, [
                            (source.url)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: source.url,
                                  target: "_blank",
                                  rel: "noopener noreferrer"
                                }, _toDisplayString(source.title || source.url), 9 /* TEXT, PROPS */, _hoisted_112))
                              : (_openBlock(), _createElementBlock("span", _hoisted_113, _toDisplayString(source.title), 1 /* TEXT */)),
                            (source.sourceType)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_114, _toDisplayString(source.sourceType), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (sourceSections(activeSourceMessage.value).length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_115, "参照ソースはありません。"))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      onClick: _cache[26] || (_cache[26] = ($event: any) => (copyAllSources(activeSourceMessage.value)))
                    }, {
                      default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                        _createTextVNode("全てのソースをコピー", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ], 32 /* NEED_HYDRATION */))
    : _createCommentVNode("v-if", true)
}
}

})